export const eng = {
    global: {
        test: "test",
        next: "Next",
        name: "Name",
        email: "Email",
        view: "View",
        edit: "Edit",
        close: "Close",
        Close: "Close",
        DOWNLOAD: "DOWNLOAD",
        submit: "Submit",
        ADD: "ADD",
        CANCEL: "CANCEL",
        SAVE: "SAVE",
        DELETE: "DELETE",
        Delete: "Delete",
        Duplicate: "Duplicate",
        SHARE: "SHARE",
        no: "No",
        type: "Type",
        english: "English",
        thai: "Thai",
        emailEtc: "name@example.com",
        ark_for_help: "Ask for help",
        Search: "Search",
        workspace: "Workspace",
        language: "Language",
        logout: "Logout",
        search_results: "Search Results",
        Confirm: "Confirm",
        Cancel: "Cancel",
        account_switcher: {
            add_account: "Add Account",
            log_out: "Log Out",
            log_out_of: "Log out of",
            switch_failed: "Failed to switch account",
            sign_in_plus_email: "Sign in with a + email",
            your_accounts: "Your accounts",
            email_address: "Email address",
            sending: "Sending...",
            continue: "Continue",
            code_sent_to: "Code sent to",
            verification_code: "Verification code",
            four_digit_code: "4-digit code",
            verifying: "Verifying...",
            different_email: "Different email",
        },
        Save: "Save",
    },
    category: {
        power_skill: {
            empathy: "Empathy",
            self_awareness: "Self-awareness",
            leadership: "Leadership",
            initiative_making: "Initiative-making",
            optimism: "Optimism",
            critical_thinking: "Critical Thinking",
        },
        frequency: {
            one_time: "One-time",
            weekly: "Weekly",
            monthly: "Monthly",
            quarterly: "Quarterly",
            biannually: "Biannually",
            yearly: "Yearly",
        },
        day_of_week: {
            monday: "Monday",
            tuesday: "Tuesday",
            wednesday: "Wednesday",
            thursday: "Thursday",
            friday: "Friday",
            saturday: "Saturday",
            sunday: "Sunday",
        },
        day_of_week_m: {
            mon: "Mon",
            tue: "Tue",
            wed: "Wed",
            thu: "Thu",
            fri: "Fri",
            sat: "Sat",
            sun: "Sun",
        },
        Talent_Types: {
            Starter: "Starter",
            Marginalized: "Marginalized",
            Latent_Potential: "Latent Potential",
            Up_and_coming: "Up-and-coming",
            Supported: "Supported",
            Underutilized: "Underutilized",
            Contributor: "Contributor",
            Rising_Star: "Rising Star",
            High_Contributor: "High Contributor",
            Activated: "Activated",
            Crowd_Favorite: "Crowd Favorite",
            Developing: "Developing",
            Community_Pillar: "Community Pillar",
            Key_Player: "Key Player",
            Respected_Expert: "Respected Expert",
            Distinguished_Talent: "Distinguished Talent",
            Engaged_Contributor: "Engaged Contributor",
            Valued_Contributor: "Valued Contributor",
            Untapped_Potential: "Untapped Potential",
            Emerging_Talent: "Emerging Talent",
            Core_Player: "Core Player",
            High_Performer: "High Performer",
            Hidden_Talent: "Hidden Talent",
            Unsung_Talent: "Unsung Talent",
            High_Potential: "High Potential",
            Solid_Performer: "Solid Performer",
            Superstar: "Superstar",
        },
        Network_type: {
            Low_Network: "Low Network",
            Medium_Inner: "Medium Inner",
            High_Inner: "High Inner",
            Super_Inner: "Super Inner",
            Medium_Outer: "Medium Outer",
            High_Outer: "High Outer",
            Super_Outer: "Super Outer",
            Medium_Network: "Medium Network",
            High_Network: "High Network",
            Super_Network: "Super Network",
        },
    },
    page: {
        awards: "Awards",
        awardsDescription: "Get recognized as a top employer with behavior-driven metrics",
        status: "Status",
        timeLine: "Timeline",
        billing: "Billing",
        billing_description: "Review subscription charges, reward activity and credit top-ups by billing period",
        happilyVillage: "Happily Village",
        happilyVillage_description: "View and manage village interactions and experiences",
        overview: "Overview",
        university: "University",
        townHall: "Town Hall",
        runningTrack: "Running Track",
        battleStadium: "Battle Stadium",
        insights: "Insights",
        insights_description: "Real-time data and insights into your teams and people",
        skills: "Skills",
        skills_description: "Identifying strengths and opportunities for learning and development",
        programs: "Programs",
        programs_description: "Guided multi-week experiences for onboarding, leadership, well-being, and compliance",
        dashboard: "Dashboard",
        teams: "Teams",
        cohorts: "Cohorts",
        managers: "Managers",
        people: "People",
        reportCard: "Report Card",
        integrations: "Integrations",
        integrations_description: "Sync employee data and connect with other services",
        HRIS_Sync: "HRIS Sync",
        API: "API",
        members: "Members",
        members_description: "Manage your members, teams, and managers",
        power_up: "Power-ups",
        power_up_description: "Send recognition to awesome people",
        recognition: "Recognition",
        recognition_description: "Send recognition to awesome people",
        performance: "Performance",
        performance_description: "Track performance towards culture and goals and understand focus areas",
        focus_areas: "Focus Areas",
        goals: "Goals",
        coming_soon: "Coming soon...",
        create: "Create",
        outbox: "Outbox",
        activity: "Activity",
        questions: "Questions",
        questions_description: "Manage questions, add your own, and view responses",
        standard: "Standard Library",
        custom: "Custom Questions",
        reports: "Reports",
        reports_description: "Preview and download auto-generated reports",
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        rewards: "Rewards",
        rewards_description: "Manage your Gift Cards and Company Rewards",
        gift_cards: "Gift Cards",
        perks: "Perks",
        team_building: "Team Building",
        doing_good: "Doing Good",
        merchandise: "Merchandise",
        "%_merchandise_%": "Merchandise",
        setup_wizard: "Setup Wizard",
        setup_wizard_description: "Let’s get you set up! You are minutes away from a happier workplace.",
        sparks: "Sparks",
        sparks_description: "Transform how your employees and managers approach problems",
        micro_learning: "Micro-Learning",
        leaderboards: "Leaderboards",
        settings: "Settings",
        settings_description: "Manage your account, members, and preferences",
        statusPage: "Status Page",
        statusPage_description: "Check the live status of Happily services",
        documentation_dev: "Documentation(Dev)",
        login_title: "Login",
        pincode_title: "Pincode",
        relationship_mapping: "Relationship Mapping",
        reward_message: "Reward Message",
        user_registration: "User Registration",
        nav_groups: {
            analyze: "Analyze",
            manage: "Manage",
            develop: "Develop",
            engage: "Engage",
            admin: "Admin",
        },
    },
    commponents: {
        years: "years",
        months: "months",
        days_ago: "days ago",
        joined_after: "joined after",
        joined: "Joined",
        daily_streak: "Daily Streak",
        achievements: "Achievements",
        super_feedback: "Super Feedback",
        MOST_RECENT: "MOST RECENT",
        power: "Power",
        badges: "Badges",
        org: "Org",
        relationships: "Relationships",
    },
    setupWizard: {
        stepOne: {
            title: "Welcome",
            hi: "Hi",
            header: "Welcome to Happily!",
            contentOne: "You’re awesome for initiating positive experiences in your workplace. With Happily, you’re enabling better feedback, recognition, learning, community and so much more!",
            contentTwo: "To get started, we need to get your team set up, select rewards, and send out invites. Let’s begin!",
            What_are_your: "What are your company’s core values?",
        },
        stepTwo: {
            title: "Create Team",
            header: "Create Your Team",
            contentOne: "Happily works in teams and managers are at the center. Feedback, Insights, and Reports are sent to team managers on each workday to help them better understand their team in real-time. Help us set up your team.",
            teamName: "Team Name",
            teamNameEtc: "ACME Inc",
            managersNameEt: "Manager’s Name",
            email: "Email",
            memberName: "Member Name",
        },
        stepThree: {
            title: "Select Rewards",
            contentOne: "Your team can use coins and gems collected from answering daily questions (and other interactions) to redeem rewards! Select your rewards below. You can add custom rewards later on as well.",
            SelectOneTitle: "Company Perks",
            SelectOneContentOne: "Start with our curated selection of workplace benefits that reward your most engaged employees.",
            SelectOneContentTwo: "Rewards can be configured from your admin console.",
            SelectTwoTitle: "Gift Cards (not available in the trial)",
            SelectTwoContentOne: "Let your team redeem Gift Cards from local vendors and online stores.",
            SelectTwoContentTwo: "Buy credits to enable gift cards, no extra charges applied.",
        },
        stepFour: {
            title: "Confirm & Invite",
            contentOne: "We’re almost done! Set a time you’d like your teams to receive their daily pulse questions. We recommend selecting the time when your team is commuting to work.",
            quickSettings: "QUICK SETTINGS",
            dailyPulse: "Daily Pulse",
            whatHappensNext: "WHAT HAPPENS NEXT",
            contentOneWhatHappensNext: "Invitations will be sent out to your team and everyone will receive their first set of daily pulse questions on the next workday.",
            contentTwoWhatHappensNext: "Explore your admin console to add members, view insights, create custom questions & rewards, or edit your account settings.",
        },
    },
    fourZeroFour: {
        looks_like_somehing: "Looks like something went wrong",
        the_page_you: "the page you are looking for is not available!",
        home_page: "Home Page",
    },
    awards: {
        happily_awards: "Happily Awards",
        recognition_driven: "Recognition-driven",
        the_practice_of: "The practice of recognition drives positive reinforcement and is critical to motivating top talent and creating high-performing teams",
        past_thirty_day_participation: "Past 30 day participation",
        required: "Required",
        or_higher: "or higher",
        open_feedback: "Open Feedback",
        continuous_feedback_drives: "Continuous feedback drives continuous improvement and signals a high psychological safety work environment",
        past_thirty_day_open: "Past 30 day open feedback rate",
        active_managers: "Active Managers",
        people_managers_are: "People managers are in the best position to proactively help, engagement, and retain talent on their team",
        past_thirty_day_activity: "Past 30 day activity",
        strong_company_culture: "Strong Company Culture",
        culture_is_a_byproduct: "Culture is a byproduct of core values and behaviors. A strong culture allows you to execute strategy effectively and innovate",
        most_recent_culture: "Most recent Culture Index score",
        high_well_being: "High Well-being",
        employee_wellness_and: "Employee wellness and well-being deserves attention and care, and directly contributes to organizational resilience",
        most_recent_WHO_5: "Most recent WHO-5 Index score",
        happiest_workplace: "Happiest Workplace",
        a_happy_workplace: "A happy workplace is driven by positive habits — recognition, open feedback, active manages, strong culture, and high well-being",
        awards_collected: "Awards collected",
        collect_all_other: "Collect all other awards",
        share_your_award: "Share your award",
        share_your_award_with: "Share your award with others. Your award has been published and is ready to view at the web address below.",
        coppy: "Coppy",
        embed_code: "Embed code",
        preview_link_in: "Preview link in new tab",
        to_embed_this: "To embed this award on your website, simply copy and paste the code below into the HTML code on your website.",
        all_time: "All-Time",
        consistency: "Consistency",
        current_streak: "Current Streak",
        start_date: "Start Date",
        january_one: "January 1",
        today: "Today",
        highlighted_are_periods: "Highlighted are periods when recognition participation is",
        days: "days",
        required_collect_all: "Required: Collect all other awards",
    },
    billing: {
        BILLING_SUMMARY: "BILLING SUMMARY",
        SUBSCRIPTION: "SUBSCRIPTION",
        REWARDS_CHARGES: "REWARDS CHARGES",
        REWARD_CREDIT_BALANCE: "REWARD CREDIT BALANCE",
        REWARDS_PENDING: "REWARDS PENDING",
        active_members: "Active Members",
        credit_balance: "Credit Balance",
        credit_remaining: "Credit Remaining",
        Date: "Date",
        Category: "Category",
        Description: "Description",
        Amount: "Amount",
        Status: "Status",
        seats_charged: "seats charged",
        export: "Export",
        top_up_credits: "TOP-UP CREDITS",
        bill_sent: "Bill Sent",
        all: "All",
        copy: "Copy",
        copied_to_clipboard: "Copied to clipboard!",
        no_data_to_copy: "No data to copy",
        failed_to_copy: "Failed to copy to clipboard",
        unable_to_load: "Billing data could not be loaded",
        try_again: "Try again",
        account_billing: "Account billing",
        billing_period: "Billing period",
        export_summary: "Export summary",
        live_calculation_note: "This page is a live calculation based on recorded activity and current billing rules. Your final invoice is prepared by Happily's billing team.",
        period_overview: "Period overview",
        how_charges_add_up: "How your charges add up",
        pending_separate: "Pending reward commitments are shown separately and are not included in calculated charges.",
        recorded_charges: "Calculated charges",
        charge_calculation: "Subscription plus rewards charged plus credit top-ups equals calculated total",
        subscription_label: "Subscription",
        rewards_charged: "Rewards charged",
        credit_top_ups: "Credit top-ups",
        recorded_total: "Calculated total",
        available_reward_credit: "Available reward credit",
        available_reward_credit_help: "Credit currently available for reward redemptions.",
        pending_reward_commitments: "Pending reward commitments",
        pending_reward_commitments_help: "Reward value requested but not yet completed or charged.",
        no_charges: "No calculated charges",
        no_charges_help: "There are no subscription, reward or top-up charges for this period.",
        seat_evidence: "Member usage",
        Country: "Country",
        member_usage_country: "Active members by country",
        country_usage_help: "See how active members were distributed across countries in this billing period. Charges above are grouped by billing currency.",
        share_of_usage: "Share of active members",
        last_activity: "Last activity",
        view_members: "View members",
        no_member_activity: "No member activity",
        no_member_activity_help: "No active members were recorded in this billing period.",
        charge_details: "Charge details",
        billing_activity: "Billing activity",
        billing_activity_help: "See the entries behind this period's calculation, grouped by charge type.",
        subscription_charges: "Subscription charges",
        subscription_charges_help: "Membership charges based on active members and any minimum seat commitment.",
        reward_credit_topups: "Reward credit top-ups",
        reward_credit_topups_help: "Credit added to your reward wallet during this billing period.",
        reward_redemptions: "Reward redemptions",
        reward_redemptions_help: "Member reward requests, including charged, pending and canceled entries. Only charged entries are included in the calculated total above.",
        member_subscription: "Member subscription",
        reward_credit_topup: "Reward credit top-up",
        reward_redemption: "Reward redemption",
        other_billing_activity: "Other billing activity",
        other_billing_activity_help: "Additional billing entries that do not match the standard subscription, top-up or redemption categories.",
        less_than_one_percent: "<1%",
        entry: "entry",
        entries: "entries",
        no_activity: "No billing activity",
        no_activity_help: "There are no billing entries for this period.",
        copy_list: "Copy list",
        download_csv: "Download CSV",
        current_period: "Current period",
        period_range_pending: "The billing range will appear when activity has loaded.",
        calculating: "Calculating",
        finalised: "Finalised",
        in_progress: "In progress",
        waiting_for_activity: "Waiting for billing activity",
        updated_at: "Updated",
        all_countries: "All countries",
        billable_member_activity: "Member activity",
        not_available: "Not available",
        pending: "Pending",
        charged: "Charged",
        paid: "Paid",
        canceled: "Canceled",
        allow_popups: "Allow pop-ups to open the billing export.",
        load_error_help: "Refresh the data or try again in a moment.",
    },
    happilyVillage: {
        reels: {
            reel: "Reel", reels: "Reels", posts: "Posts", townhall_content: "Town Hall content",
            new_reel: "New reel", close: "Close editor", back_to_reels: "Back to reels", starter: "HR starter", upload_video: "Upload a video", build_reel: "Build a reel",
            templates: { company_update: "Company update", welcome_team: "Welcome teammates", recognition: "Recognition or milestone", leadership_message: "Leadership message", event: "Event reminder or recap", policy: "Policy or deadline", blank: "Blank reel" },
            storyboard: "Storyboard", scenes: "Scenes", preview: "Preview", edit: "Edit", editor_sections: "Reel editor sections",
            drag_scene: "Drag scene {n}", move_up: "Move up", move_down: "Move down", duplicate_scene: "Duplicate scene", delete_scene: "Delete scene", add_scene: "Add scene", untitled_scene: "Untitled scene", one_scene_required: "A reel needs at least one scene.", scene_moved: "{title} moved to position {n} of {total}.", editing_scene: "Editing scene {n}, {title}.", scene_of: "Scene {current} of {total}", scene_type: "Scene type",
            total_duration: "Total duration", recommended_duration: "Recommended 30–60 seconds", preview_reel: "Preview · Reel", preview_hint: "This is how it will appear in the mobile app.", preview_title_fallback: "Tell your team something worth seeing", top_safe_zone: "Top safe zone", bottom_safe_zone: "Bottom safe zone", play: "Play", pause: "Pause", mute: "Mute", live_preview: "Live preview", scene_label: "Scene", preview_scenes: "Preview scenes", unmute: "Turn sound on", scene_content: "Message", look_and_timing: "Look & timing",
            text: "Text", photo: "Photo", video: "Video", media: "Media", no_media: "No media selected", choose: "Choose", replace: "Replace", headline: "Headline", supporting_text: "Supporting text", visual_style: "Visual style", layout: "Layout", styles: { brand: "Brand", midnight: "Midnight", spotlight: "Spotlight", fresh: "Fresh", paper: "Paper" }, layouts: { statement: "Statement", center: "Centered", lower_third: "Lower third", editorial: "Editorial" }, text_effect: "Text effect", text_effects: { none: "Still", "soft-rise": "Soft rise", "side-reveal": "Side reveal", focus: "Focus", stagger: "Stagger", highlight: "Highlight" }, text_effect_descriptions: { none: "Always visible, with no motion.", "soft-rise": "Gently lifts the message into place.", "side-reveal": "Slides in with a confident start.", focus: "Scales in softly for emphasis.", stagger: "Brings in the headline, then the details.", highlight: "Draws an accent line before the message." }, effect: "Media effect", effects: { natural: "Natural", studio: "Studio", cinematic: "Cinematic", sunlit: "Sunlit", vibrant: "Vibrant", mono: "Monochrome" }, effect_descriptions: { natural: "No added treatment", studio: "Clean, softly polished", cinematic: "Deeper contrast, slow push", sunlit: "Warm light, gentle drift", vibrant: "Rich colour, subtle lift", mono: "Timeless black and white" }, effect_hint: "Each preset pairs tone and motion. Press play to preview movement.", duration: "Duration", fit: "Fit", contain: "Contain", cover: "Cover", focal_point: "Focal point", horizontal: "Horizontal", vertical: "Vertical", focal_point_help: "Choose the part that must stay visible when the media fills the frame.", poster_frame: "Poster frame", poster_auto: "Automatic", poster_choose_frame: "Choose frame", poster_at: "Frame at", transition: "Transition", crossfade: "Crossfade", none: "None",
            finished_video: "Finished video", upload_finished_video: "Upload your finished reel", upload_limits: "MP4 or MOV · up to 500 MB and 3 minutes", choose_video: "Choose video", video_too_large: "Choose a video smaller than 500 MB.", video_too_long: "Choose a video that is 3 minutes or shorter.",
            global_audio: "Global audio", clip_audio: "Clip audio", optional_track: "Optional music or narration", choose_audio: "Choose audio", reel_details: "Reel details", title: "Title", caption: "Caption", tags: "Tags", add_tag: "Add a tag", subtitles_accessibility: "Subtitles & accessibility", subtitle_help: "If the reel contains speech, add an SRT or VTT file. Subtitles will be placed above the mobile safe zone.", choose_subtitles: "Choose subtitle file",
            audience: "Audience", all_employees: "All employees", selected_groups: "Selected groups", notification: "Notification", push: "Push notification", push_notice: "This will send a push notification", push_notice_help: "People are notified when the reel is live.", publish_when: "Publish when", now: "Now", schedule: "Schedule", pick_date: "Pick a date and time", save_close: "Save & close", publish_reel: "Publish reel", schedule_reel: "Schedule reel",
            draft: "Draft", saving: "Saving…", draft_saved: "Draft saved", save_failed: "Couldn’t save", retry: "Retry", save_changes: "Save changes?", close_prompt: "Save this reel as a draft, or discard your edits?", discard: "Discard", fix_before_publish: "Fix these before publishing:", template_applied: "Starter applied. Everything is editable.", published_success: "Your reel is live.", scheduled_success: "Your reel is scheduled.", publish_failed: "Could not publish the reel. Please try again.", unpublished: "Unpublished",
            filter_reels: "Filter reels", filters: { all: "All", draft: "Drafts", rendering: "Rendering", scheduled: "Scheduled", published: "Published", failed: "Needs attention", archived: "Archived" }, search_reels: "Search reels or #tags", no_reels: "No reels here yet", no_reels_help: "Create a company update, welcome new teammates, or upload a finished video.", create_first: "Create your first reel", untitled_reel: "Untitled reel", no_caption: "No caption yet", reel_actions: "Reel actions", retry_render: "Retry render", cancel_render: "Cancel render", cancel_render_prompt: "Stop preparing this reel? Your draft and uploaded media will be kept.", cancel_schedule: "Cancel schedule", unpublish: "Unpublish", unpublish_reel: "Unpublish reel", unpublish_prompt: "Remove this reel from Town Hall? Its engagement history will be kept, and you can edit or publish it again.", archive: "Archive", archive_reel: "Archive reel", archive_prompt: "Move this reel to Archived? If it is live, it will be removed from Town Hall. Engagement history will be kept.", archived_help: "This reel is archived and hidden from the active outbox. Its engagement history is still available.", restore: "Restore", view_engagement: "View engagement", refresh_metrics: "Refresh metrics", metrics_failed: "Could not refresh engagement metrics.", scheduled_for: "Scheduled for", render_failed_help: "This reel could not be prepared. Your draft and media are safe.", rendering_help: "Preparing the mobile video. You can leave this page.", select_reel: "Select a reel", select_reel_help: "Choose a reel to preview it and manage publishing.", updated: "Updated", not_set: "Not set", performance: "Performance", engagement_summary: "Engagement summary", mobile_activity: "Mobile activity", views: "Views", completions: "Completions", reactions: "Reactions", completion_rate: "Completion rate", finish_publish: "Review & publish", review_schedule: "Review schedule", duplicate_reel: "Duplicate reel",
            delete_reel: "Delete reel", delete_prompt: "Delete this reel and its draft media? This cannot be undone.", deleted: "Reel deleted.", load_failed: "Could not load reels. Please try again.", action_failed: "Could not update the reel. Please try again.", actions: { duplicate: "Reel duplicated.", retry: "Render queued again.", cancel_render: "Render cancelled.", cancel_schedule: "Schedule cancelled.", unpublish: "Reel unpublished.", archive: "Reel archived.", restore: "Reel restored." },
            errors: { title_required: "Add a reel title.", caption_required: "Add a short caption so the update is understandable without sound.", title_too_long: "Keep the title to 80 characters or fewer.", caption_too_long: "Keep the caption to 280 characters or fewer.", upload_required: "Upload a finished video.", scenes_required: "Add at least one scene.", too_many_scenes: "A reel can have up to 10 scenes.", too_long: "Built reels can be up to 90 seconds.", scene_media_required: "Add the missing photo or video to scene {scenes}, or switch it to a text scene." },
            starter_prompt: "Applying a different starter will replace your current scenes. Continue?", apply_starter: "Apply starter", video_unsupported: "That video file could not be read. Choose an MP4 or MOV file.",
            motion_effects: "Motion & effects", soundtrack: "Soundtrack", your_audio: "Your audio", music_hint: "The soundtrack is mixed in when the mobile video is prepared.",
            tracks: { none: "No music", uplift: "Uplift", calm: "Calm", energy: "Energy", warm: "Warm", focus: "Focus" },
            track_descriptions: { none: "Voices and clip audio only", uplift: "Bright and optimistic", calm: "Soft and steady", energy: "Fast and bold", warm: "Friendly and human", focus: "Minimal and modern" },
            show_branding: "Company branding", show_branding_help: "Show your logo and company name on the reel."
        },
        Session_Type: "Type",
        Live: "Live",
        Video: "Video",
        Mission_Entries: "Mission Entries",
        Mission: "Mission",
        add_mission: "add mission",
        Order: "Order",
        Mission_Name_and: "Mission Name & Description",
        Entries: "Entries",
        Winner: "Winner",
        Status: "Status",
        Week: "Week",
        entries: "entries",
        Live: "Live",
        Completed: "Completed",
        Unskip_Mission: "Unskip Mission",
        Skip_Mission: "Skip Mission",
        Edit: "Edit",
        Delete: "Delete",
        Upcoming: "Upcoming",
        View_Details: "View Details",
        Preview_on_Mobile: "Preview on Mobile Layout",
        New_Mission: "New Mission",
        Exntry_XP: "Entry XP",
        PLAY: "PLAY",
        VOTE: "VOTE",
        Name_of_Mission: "Name of Mission",
        Please_input_Name: "Please input Name",
        Name_of_your_Mission: "Name of your Mission (e.g., Take the best group selfie)",
        Name_of_your_Mission_th: "Name of your Mission (Thai)",
        Description: "Description",
        A_sentence_or_two: "A sentence or two about this topic",
        Please_input_Description: "Please input Description",
        Please_input_Session_Minimum: "Please input Session Minimum",
        A_sentence_or_two_th: "A sentence or two describing the mission details (Thai)",
        Mission_Type: "Mission Type",
        Please_input_Mission_Type: "Please input Mission Type",
        Entry_Bonus_XP: "Entry Bonus (XP)",
        Please_input_Entry_Bonus: "Please input Entry Bonus",
        Please_input_Order: "Please input Order",
        Select: "Select",
        Please_input_Status: "Please input Status",
        CREATE_MISSION: "CREATE MISSION",
        SAVE_MISSION: "CREATE MISSION",
        HAPPILY_HOUSES: "HAPPILY HOUSES",
        THIS_WEEK: "THIS WEEK",
        This_Week: "This Week",
        This_Month: "This Month",
        Last_Week: "Last Week",
        Last_Month: "Last Month",
        All_time: "All-time",
        Level: "Level",
        total_members: "total members",
        House_XP: "House XP",
        XP: "XP",
        person: "person",
        Distance: "Distance",
        km: "km",
        km_per_person: "km / person",
        participation: "Participation",
        university: "university",
        A_count_of_how_many_learning: "A count of how many learning and activity interactions have been created from University sessions",
        Learning_and_Activity: "Learning & Activity Interactions",
        See_more: "See more",
        town_hall: "town hall",
        A_count_of_how_many_comments: "A count of how many comments and replies have been initiated through topic and polls in the Town Hall",
        Knowledge_Sharing_Interactions: "Knowledge Sharing Interactions",
        running_track: "running track",
        A_count_of_distance_traveled: "A count of distance traveled by walking and running on the Running Track, including the effect of Boosters",
        km_Distance_Traveled: "km Distance Traveled",
        BATTLE_STADIUM: "BATTLE STADIUM",
        A_count_of_how_many_entries: "A count of how many entries have been submitted towards weekly missions in the Battle Stadium",
        House_of: "House of",
        members: "members",
        making_up: "making up",
        of_Happily_Village: "of Happily Village",
        Distance_Traveled: "Distance Traveled",
        Running_Track_Leaderboard: "Running Track Leaderboard",
        Today: "Today",
        Rank: "Rank",
        Name: "Name",
        results_from: "results from",
        results: "results",
        This_week: "This week",
        No_Active_Boosters: "No Active Boosters",
        This_month: "This month",
        Quick_ranges: "Quick ranges",
        Specific_month: "Specific month",
        Export_this_view: "Export this view",
        Export_complete: "Export complete.",
        months_short: {
          jan: "Jan", feb: "Feb", mar: "Mar", apr: "Apr",
          may: "May", jun: "Jun", jul: "Jul", aug: "Aug",
          sep: "Sep", oct: "Oct", nov: "Nov", dec: "Dec",
        },
        Town_Hall_Topics: "Town Hall Topics, Polls, & Group Checklists",
        Create: "Create",
        New_Topic: "New Topic",
        New_Poll: "New Poll",
        New_Checklist: "New Checklist",
        Creator: "Creator",
        Type: "Type",
        View: "View",
        Views: "Views",
        Engagement: "Engagement",
        Date_and_Time: "Date & Time",
        Duplicate: "Duplicate",
        comment: "comment",
        comments: "comments",
        votes: "votes",
        By: "By",
        Topic_Creator: "Topic Creator",
        Share_with: "Share with",
        Huddle_selection_is: "Huddle selection is currently only available in the mobile app.",
        Coming_soon_to: "Coming soon to the My Happily console.",
        Team_or_Name: "Team or Name of Recipient",
        Title_of_Topic: "Title of Topic",
        Title_of_Poll: "Title of Poll",
        Short_but_descriptive: "Short but descriptive",
        A_sentence_or_two_poll: "A sentence or two about this poll",
        Item_label: "Item label",
        Comments_enabled: "Comments enabled",
        UPLOAD_MEDIA: "UPLOAD MEDIA",
        Save_Changes: "Save Changes",
        CREATE_TOPIC: "CREATE TOPIC",
        by: "by",
        Summary: "Summary",
        items: "items",
        You_are_completed: "You’ve completed",
        Weekly_reminders_to: "Weekly reminders to update your progress is on",
        Group_Checklist_Creator: "Group Checklist Creator",
        Select_Creator: "Select Creator",
        Title_of_Checklist: "Title of Checklist",
        Please_input_title: "Please input title",
        Checklist_Item: "Checklist Item",
        Description_of_Checklist: "Description",
        Checklist_item_type: "Item type",
        Item_type_simple: "Simple",
        Item_type_acknowledge: "Acknowledge",
        Item_type_link: "Link",
        Item_required: "Required",
        Acknowledge_what: "What should they acknowledge?",
        Link_placeholder: "https://...",
        Due_date: "Due date (optional)",
        Remind_7_days_before: "Remind 7 days before",
        Remind_1_day_before: "Remind 1 day before",
        Tags: "Tags",
        Add_tag: "Add a tag",
        ADD_OPTION: "ADD OPTION",
        Show_respondents_in_results: "Show respondents in results",
        Weekly_Reminders_off: "Weekly Reminders off",
        Every_week_on: "Every week on",
        at: "at",
        if_checklist_is: "if checklist is incomplete, send a reminder notification",
        CREATE_CHECKLIST: "CREATE CHECKLIST",
        CREATE_POLL: "CREATE POLL",
        Poll_Creator: "Poll Creator",
        Poll_Title: "Poll Title",
        Option: "Option",
        Option_label: "Option label",
        Search: "Search",
        learning_and_activity_interactions: "learning & activity interactions",
        University_Sessions: "University Sessions",
        add_session: "add session",
        campaigns: "Campaigns",
        Create_Campaign: "Create Campaign",
        Campaign_Title: "Campaign Title",
        Icon: "Icon",
        Theme: "Theme",
        Input_Type: "Input Type",
        Timing: "Timing",
        Goal: "Goal",
        Reward: "Reward",
        Entry_Cost: "Entry Cost",
        Daily: "Daily",
        Weekly: "Weekly",
        Instant_Coins: "Instant Coins",
        Charged_Coins_On_Completion: "Charged Coins on Completion",
        Prize_Pool_Split_At_End: "Prize Pool (Split at End)",
        Individual_Goal: "Individual Goal",
        Group_Goal: "Group Goal",
        Start_Date: "Start Date",
        End_Date: "End Date",
        Participants: "Participants",
        All: "All",
        Sign_ups: "Sign ups",
        name: "name",
        Topic: "Topic",
        Price: "Price",
        coins: "coins",
        Free: "Free",
        Led_by: "Led by",
        SIGN_UPS: "SIGN UPS",
        spots_available: "spots available",
        PRICE: "PRICE",
        Coming_soon_to_the: "Coming soon to the My Happily console.",
        Name_of_Session: "Name of Session",
        Short_but_descriptive_eg: "Short but descriptive (eg. Excel Analysis 101)",
        A_sentence_or_two_about: "A sentence or two about the session",
        When: "When",
        Please_input_Date: "Please input Date & Time",
        Duration_minutes: "Duration (minutes)",
        How_long: "How long?",
        Please_input_Duration: "Please input Duration",
        Location: "Location",
        Please_input_Location: "Please input Location",
        Session_Limit: "Session Limit",
        Where: "Where",
        How_many: "How many?",
        Please_input_Session_Limit: "Please input Session Limit",
        Price_coins: "Price (coins)",
        Please_input_rice: "Please input Price",
        How_much: "How much?",
        Add_to_Topic: "Add to Topic",
        Comment_Permissions: "Comment Permissions",
        CREATE_SESSION: "CREATE SESSION",
        Created_by: "Created by",
        sign_ups_of: "sign ups of",
        available_spots: "available spots",
        No_one_sign_up: "No one sign up.",
        campaign_form: {
            preview_notice: "Features may change before official release.",
            content_language: "Content Language",
            translation_mode_title: "Only translatable fields are shown below.",
            translation_mode_hint: "Switch to English to edit all campaign settings.",
            use_english_empty: "Use English for Empty Fields",
            use_english: "Use English",
            live_lock_title: "Live campaign editing is limited.",
            live_lock_body: "You can still update display fields like category, title, description, icon, theme, and comment permissions. Timing, goals, rewards, audience, entry settings, and activity content are locked after a campaign starts.",
            translatable_content: "Translatable Content",
            campaign_overview: "Campaign Overview",
            category: "Category",
            category_placeholder: "e.g., PRODUCT KNOWLEDGE, WELLNESS",
            activity_type: "Activity Type",
            activity_type_placeholder: "Select activity type",
            title: "Title",
            title_placeholder: "Enter campaign title or question",
            description: "Description",
            description_placeholder: "Describe what this campaign is about and what participants will do...",
            description_hint: "This description will be shown to participants when they join the campaign",
            translation_required: "Translation required",
            validation_category: "Please enter a campaign category",
            validation_title: "Please enter a campaign title",
            validation_icon: "Please select an icon",
            color_theme: "Color Theme",
            activity_settings: "Activity Settings",
            locked_after_start: "Locked after the campaign starts.",
            success_answer: "Success Answer",
            yes_is_correct: "Yes is the correct answer",
            no_is_correct: "No is the correct answer",
            input_settings: "Input Settings",
            allow_decimals: "Allow decimal values",
            allow_decimals_hint: "Enable for weight, distance, or other metrics requiring precision (e.g., 1.5, 0.8)",
            tracking_mode: "Tracking Mode",
            incremental: "Incremental",
            incremental_hint: "Each entry is independent (e.g., \"1.5 lbs lost this week\")",
            cumulative: "Cumulative",
            cumulative_hint: "Each entry is total from campaign start (e.g., \"5 lbs lost total\")",
            campaign_duration: "Campaign Duration",
            duration_locked: "Start and end timing are locked after the campaign starts.",
            select_frequency: "Select frequency",
            day_of_week: "Day of the Week",
            select_day: "Select day",
            select_start_date: "Select start date",
            number_of_days: "Number of Days",
            number_of_weeks: "Number of Weeks",
            ends: "Ends",
            unit_translation: "Unit Translation",
            unit_of_measurement: "Unit of Measurement",
            unit_placeholder: "e.g., items, steps, minutes",
            unit_hint: "This unit will be displayed with all goals (e.g., \"10 items\", \"1000 steps\")",
            goals: "Goals",
            goals_locked: "Goal settings are locked after the campaign starts.",
            limit: "Limit",
            required: "Required",
            optional: "Optional",
            target: "Target",
            max_allowed: "Max allowed",
            max_total: "Max total",
            target_total: "Target total",
            max_combined: "Max combined",
            target_combined: "Target combined",
            individual_overall_goal: "Individual Overall Goal",
            individual_overall_limit: "Individual Overall Limit",
            group_overall_goal: "Group Overall Goal",
            group_overall_limit: "Group Overall Limit",
            recommended: "Recommended",
            weeks: "Weeks",
            days: "Days",
            yesno_desc_daily: "Participants succeed by answering correctly each day",
            yesno_desc_weekly: "Participants succeed by answering correctly each week",
            reward_locked: "Reward mechanics are locked after the campaign starts to protect payout logic.",
            earn_per_item: "Earn per completed item when daily goal reached",
            earn_on_daily_goal: "Earn only when daily goal reached",
            charged_coins: "Charged Coins",
            prize_pool: "Prize Pool",
            prize_pool_description: "Entry costs + charged coins create a pool, split equally among winners",
            access_participation: "Access & Participation",
            access_locked: "Audience and entry settings are locked after the campaign starts.",
            audience: "Audience",
            select_commenter: "Select who can comment",
            who_can_comment: "Who can leave comments",
            coins_to_join: "Coins to join",
            entry_limit: "Entry Limit",
            no_limit: "No limit",
            set_participant_limit: "Set participant limit",
            checklist_items: "Checklist Items",
            add_checklist_hint: "Add items that participants can check off",
            translate_checklist_hint: "Translate each checklist item",
            enter_checklist_item: "Enter checklist item",
            add_first_item: "Add First Item",
            add_another_item: "Add Another Item",
            no_checklist_to_translate: "No checklist items to translate. Add items in English first.",
            quiz_questions: "Quiz Questions",
            translate_quiz_hint: "Translate each question and its answer options",
            question: "Question",
            remove: "Remove",
            enter_question: "Enter your question",
            no_quiz_to_translate: "No quiz questions to translate. Add questions in English first.",
            add_question: "Add Question",
            add_first_question: "Add Your First Question",
            update_campaign: "Save Changes",
            create_campaign: "Create Campaign",
            launch: "Launch",
            launch_now: "Launch now",
            launch_now_sub: "Goes live right away",
            schedule_later: "Schedule for later",
            schedule_later_sub: "Pick a date and time",
            launch_datetime: "Launch date & time",
            pick_datetime: "Pick a date and time",
            scheduled_must_be_future: "Scheduled launch must be at least a minute in the future",
            launch_locked: "Launch time can't be changed once the campaign has started",
            launch_campaign: "Launch Campaign",
            schedule_campaign: "Schedule Campaign",
        },
        Actions: "Actions",
        Topic_actions: "Topic actions",
        Session_actions: "Session actions",
        No_topics_or_polls: "No topics or polls",
        No_results_found: "No results found...",
        No_sessions: "No sessions",
        No_session_found: "No session found...",
        Caption: "Caption",
        Download_Results: "Download Results",
        Be_the_first_to_comment: "Be the first to comment in this thread",
        Reply: "Reply",
        Likes: "Likes",
        Reply_here: "Reply here...",
        Comment_here: "Comment here...",
        Sessions_tab: "Sessions",
        Campaigns_tab: "Campaigns",
        Session_Minimum: "Session Minimum",
        Session_Maximum: "Session Maximum",
        one_coin: "1 coin",
        no_signups_yet: "No sign-ups yet",
        signups_empty_hint: "Users will appear here once they sign up for this campaign",
        signed_up_count: "signed up",
        signed_up_badge: "Signed up",
        signed_up_label: "Signed Up",
        no_participants_yet: "No participants yet",
        participants_empty_hint: "Participants will appear here once they join the campaign",
        achieved_goal: "achieved goal",
        Achieved_Goal: "Achieved Goal",
        coins_awarded: "coins awarded",
        starts_tomorrow: "Starts tomorrow",
        starts_in: "Starts in",
        days: "days",
        days_left: "days left",
        last_day: "Last day",
        no_data_yet: "No data yet",
        summary_empty_hint: "Summary will appear once participants join the campaign",
        investment_and_impact: "Investment & Impact",
        per_active_participant: "per active participant",
        via: "via",
        daily_goals_lower: "daily goals",
        entry_fees_collected: "Entry fees collected",
        free_entry: "Free entry",
        coins_distributed: "Coins distributed",
        coins_committed: "Coins committed",
        in_escrow: "in escrow",
        returned_to_system: "Returned to system",
        didnt_meet_goal: "didn't meet goal",
        daily_goals_hit: "Daily Goals Hit",
        total_actions: "Total Actions",
        limited_data_notice: "Limited data — projections will improve as the campaign progresses",
        projected_total_investment: "Projected total investment:",
        Active: "Active",
        achievement_rate_lower: "achievement rate",
        reward_breakdown: "Reward Breakdown",
        coins_per_daily_goal: "Coins per daily goal",
        daily_target: "Daily target",
        daily_goals_achieved: "Daily goals achieved",
        total_actions_recorded: "Total actions recorded",
        total_coins_invested: "Total coins invested",
        total_coins_committed: "Total coins committed",
        earned_by: "Earned by",
        who_met_goal: "who met goal",
        returned_from: "Returned from",
        who_didnt: "who didn't",
        in_escrow_until_end: "In escrow until campaign ends",
        total_pool_size: "Total pool size",
        current_winners: "Current winners",
        prize_per_winner: "Prize per winner",
        no_winners_yet: "No winners yet",
        campaign_results: "Campaign Results",
        progress: "Progress",
        achievement_rate: "Achievement Rate",
        avg_score: "Avg Score",
        participation_rate: "Participation Rate",
        drop_off: "Drop-off",
        view_leaderboard: "View Leaderboard",
        Close: "Close",
        coins_committed_to_behavior: "coins committed to behavior change",
        coins_earned_through_behavior: "coins earned through behavior change",
        type_quiz: "Quiz",
        type_count: "Count",
        type_auto_sync: "Auto Sync",
        type_steps: "Steps",
        type_sleep: "Sleep",
        type_screen_time: "Screen Time",
        type_exercise: "Exercise",
        type_distance: "Distance",
        type_multiple_selection: "Multiple Selection",
        type_yes_no: "Yes/No",
        status_active: "Active",
        status_upcoming: "Upcoming",
        status_scheduled: "Scheduled",
        status_ended: "Ended",
        status_archived: "Archived",
        challenge_default: "CHALLENGE",
        preview_day: "Day",
        preview_streak: "Streak",
        preview_select_answer: "Select the right answer",
        preview_todays_activity: "Today's activity count",
        preview_daily_goal: "Daily Goal",
        preview_keep_going: "Keep going! You're doing great!",
        preview_submit_count: "Submit Count",
        preview_goal_label: "Goal",
        preview_last_sync: "Last sync: 2m ago",
        preview_manually_edit: "Manually Edit",
        preview_continue: "Continue",
        preview_morning_routine: "Complete your morning routine",
        preview_done_for_now: "I'm done for now",
        preview_yesno_question: "Did you complete today's goal?",
        preview_charging: "Charging",
        early_preview: "Early Preview",
        early_preview_hint: "You have early access! This feature is coming soon to everyone.",
        no_campaigns: "No campaigns",
        period: "Period",
        campaign_actions: "Campaign actions",
        archive: "Archive",
        delete_disabled_hint: "Delete (No participants only)",
    },
    insights: {
        HAPPINESS_VS_RISK_RATE: "Happiness vs. Risk & Activity",
        Duration: "Duration",
        Last_30_days: "Last 30 days",
        Last_60_days: "Last 60 days",
        Last_13_weeks: "Last 13 weeks",
        Last_26_weeks: "Last 26 weeks",
        Last_52_weeks: "Last 52 weeks",
        Last_24_months: "Last 24 months",
        HAPPINESS: "HAPPINESS",
        RISK: "RISK",
        ACTIVE_USERS: "ACTIVE USERS",
        COHORT_STATUS: "Cohort Status",
        Sort_by: "Sort by",
        Cohorts: "Cohorts",
        Satisfaction: "Satisfaction",
        Co_Alignment: "Co. Alignment",
        Score_Distribution: "Score Distribution",
        Engagement_and_Impact: "Engagement & Impact",
        Highlighting_key_engagement_metrics: "Highlighting key engagement metrics such as eNPS, NPS, Wellness, Culture, and Employee Resilience Index scores as well as an overview of individual impact and manager activity.",
        high_impact: "high impact",
        contributors: "contributors",
        People: "People",
        managers: "managers",
        non_active: "non-active",
        active: "active",
        Managers: "Managers",
        eNPS: "eNPS",
        Report_Card: "Report Card",
        Promoters: "Promoters",
        Passives: "Passives",
        Detractors: "Detractors",
        Excellent: "Excellent",
        Fair: "Fair",
        Critical: "Critical",
        Poor: "Poor",
        point_same_benchmark: "point same benchmark",
        points: "points",
        above_benchmark: "above benchmark",
        below_benchmark: "below benchmark",
        Happiness_Rate: "Happiness Rate",
        Risk_Rate: "Risk Rate",
        View_by_team: "View by team",
        Open_ended_Feedback: "Open-ended Feedback",
        How_would_you_like: "How would you like your",
        manager_to_be_more: "manager to be more involved?",
        Activity: "Activity",
        Adoption: "Adoption",
        Members: "Members",
        Monthly_Active_Users: "Monthly Active Users",
        Weekly_Active_Users: "Weekly Active Users",
        ACTIVITY_THIS_WEEK: "ACTIVITY THIS WEEK",
        WEEKLY_ACTIVE_USERS: "WEEKLY ACTIVE USERS",
        HAPPINESS_RATE: "HAPPINESS RATE",
        RISK_RATE: "RISK RATE",
        FEEDBACK_RESPONSE_RATE: "FEEDBACK RESPONSE RATE",
        By_Job_Tenure: "By Job Tenure",
        Engagement_Trend: "Engagement Trends",
        Engagement_Trend_Desc: "The change of engagement over a 3-month period as measured by the Dynamic Engagement Behavioral Index (DEBI) for your overall company, managers, and leaders.",
        A_breakdown_of_your: "A breakdown of your activity and rates by job tenure, the duration of time an employee has worked at your company",
        Real_time_Activity: "Real-time Activity",
        PAST_12_HOURS: "PAST 12-HOURS",
        BY_HOUR: "BY HOUR",
        TOP_ACTIVITIES: "TOP ACTIVITIES",
        TIMES: "TIMES",
        Interactions_caption: "interactions",
        No_activity_yet: "No activity in the last 12 hours",
        Key_Teams_and_Cohorts: "Key Teams & Cohorts",
        Highlighting_key_groups: "Highlighting key groups that exhibit high or low scores in happiness, risk, feedback rate, or activity",
        TONE_ANALYZER: "Tone Analyzer",
        BETA: "BETA",
        TALKING_POINTS: "Talking Points",
        show_timeline: "show timeline",
        Success_Score: "Success Score",
        Dimension: "Dimension",
        Status_no_teams: "Team health",
        teams_below_healthy: "teams below healthy",
        no_team_data: "No team data yet",
        Critical_teams: "Critical teams",
        No_critical_teams: "No critical teams in this dimension",
        Loading_teams: "Loading teams…",
        responses: "responses",
        Positive: "Positive",
        Neutral: "Neutral",
        Close: "Close",
        ENGAGEMENT_BREAKDOWN_BY_TEAM: "Engagement by dimension",
        Most_teams_red: "Most teams critical",
        Biggest_drop: "Biggest drop",
        Lowest_Success_Score: "Lowest Success Score",
        Highest_Success_Score: "Highest Success Score",
        DIMENSION_DETAILS: "Dimension Details",
        Lowest_Happiness: "Lowest Happiness",
        Highest_Happiness: "Highest Happiness",
        Lowest_Risk: "Lowest Risk",
        Highest_Risk: "Highest Risk",
        ACTIVITY_OVERVIEW: "Activity Overview",
        ACTIVE: "Responsive",
        PASSIVE: "Moderate",
        INACTIVE: "Minimal",
        DAILY_INSIGHTS_OPENED: "DAILY INSIGHTS OPENED",
        WEEKLY_INSIGHTS_OPENED: "WEEKLY INSIGHTS OPENED",
        FEEDBACK_REPLY_RATE: "FEEDBACK REPLY RATE",
        BY_MANAGER: "Manager Interactions",
        Managers_activity_in: "Managers activity in opening insights and replying to team feedback over the past 30-days",
        Insights_Open_Rate: "Insights Open Rate",
        Team_Size: "Team Size",
        Feedback_Reply_Rate: "Feedback Reply Rate",
        All_Activity_Types: "All Activity Types",
        Active: "Responsive",
        Passive: "Moderate",
        Inactive: "Minimal",
        Insights_Opened: "Insights Opened",
        Feedback: "Feedback",
        Relational: "Relational",
        Team_Challenges: "Team Challenges",
        Date: "Date",
        Score: "Score",
        Challenge: "Challenge",
        Status: "Status",
        Profile: "Profile",
        Daily: "Daily",
        Weekly: "Weekly",
        Reply: "Reply",
        Super: "Super",
        Talent_Type: "Talent Type",
        Excels_At: "Excels At",
        Network_Type: "Network Type",
        Critical_Areas: "Critical Areas",
        critical_area: "critical area",
        results_from: "results from",
        results: "results",
        Lower: "Lower",
        Upper: "Upper",
        SAVE: "SAVE",
        CANCEL: "CANCEL",
        Select_all: "Select all",
        Clear: "Clear",
        Talent_Types_are_tagged: "Talent Types are tagged according to a low, rising, high, or super rating of their network effectiveness (individual's collaborative contribution to the organization) and individual rating (a evaluation of performance from their manager)",
        Cancel: "Cancel",
        Okay: "Okay",
        Power_Skills: "Power Skills",
        OUTER_NETWORK: "OUTER NETWORK",
        NETWORK_EFFECTIVENESS: "Network Effectiveness",
        PEOPLE_INTELLIGENCE: "People Intelligence",
        INDIVIDUAL_PERFORMANCE: "Individual Performance",
        INNER_NETWORK: "INNER NETWORK",
        Sort_By: "Sort By",
        Highest_Risk_Level: "Highest Risk Level",
        Lowest_Risk_Level: "Lowest Risk Level",
        Highest_Star_Count: "Highest Star Count",
        Lowest_Star_Count: "Lowest Star Count",
        Highest_Impact_Rating: "Highest Impact Rating",
        Lowest_Impact_Rating: "Lowest Impact Rating",
        Super_Network_Effectiveness: "⬆️ Super Network Effectiveness ",
        Rising_Network_Effectiveness: "⏫ Rising Network Effectiveness",
        High_Network_Effectiveness: "🔼 High Network Effectiveness",
        Low_Network_Effectiveness: "🔽 Low Network Effectiveness",
        Super_Individual_Rating: "⬆️ Super Individual Rating",
        Rising_Individual_Rating: "⏫ Rising Individual Rating",
        High_Individual_Rating: "🔼 High Individual Rating",
        Low_Individual_Rating: "🔽 Low Individual Rating",
        No_Description: "No Description",
        Problem_Areas: "Problem Areas",
        People_Impact_and: "People Impact & Risk Trends",
        RISK_LEVELS: "Risk Levels",
        AVG_IMPACT_RATING: "Avg Impact Rating",
        view_list: "view list",
        Excels_at: "Excels at",
        profiles: "profiles",
        were_tagged_by: "were tagged by their peers for this attribute",
        Name_Team_and: "Name, Team, and Happiness",
        Talent_is_classified: "Talent is classified by frequency and quality of recognition",
        coins_and_gems: "(coins and gems) received. Coins are a measure of",
        Network: "Network",
        Effectiveness: "Effectiveness",
        Gems_are_a_measure: "Gems are a measure of",
        Individual_Performance: "Individual Performance",
        Low: "Low",
        Low_frequency: "Low frequency",
        Uptake: "Uptake",
        A_recent_increase_in: "A recent increase in frequency",
        High: "High",
        High_frequency: "High frequency",
        High_frequency_and_high: "High frequency and high quality",
        Read_more_here: "Read more here",
        Impact_Rating: "Impact Rating",
        Based_on_manager_and: "Based on manager and peer recognition in the past 6-months.",
        Based_on_connections_created: "Based on connections created through peer feedback, recognition, and gifting interactions in the past 6-months.",
        Engagement_Group: "Engagement Group",
        Based_on_the_quality_and: "Based on the quality and effort of key engagement behaviors last month.",
        Truly_Outstanding: "Truly Outstanding",
        Truly_Outstanding_ratings: "Truly Outstanding ratings from Peer Feedback received in the past 6-months.",
        Medals: "Medals",
        Medals_received_in_the: "Medals received in the past 6-months.",
        Star_Performer: "Star Performer",
        Number_of_weeks_qualified: "Number of weeks qualified as a Star Performer in the past 6-months.",
        Talent_is_classified_by: "Talent is classified by the number of inner and outer",
        connections_as_determined: "connections (as determined by the org structure) from",
        recognition_and_peer: "recognition and peer feedback data",
        Low_Network: "Low Network",
        Low_inner_and_outer: "Low inner and outer connections",
        High_Inner: "High Inner",
        High_Inner_but_low: "High inner but low outer connections",
        High_Outer: "High Outer",
        Low_inner_but_high: "Low inner but high outer connections",
        High_Network: "High inner and outer connections",
        Achievements: "Achievements",
        Risk_Level: "Risk Level",
        Talent_that_are_retention: "Talent that are retention risks detected from the frequency",
        of_Not_Great_and: "of “Not Great” and “Unhappy” responses related to “How are",
        you_feeling_today: "you feeling today?”",
        Twice_last_week: "Twice last week",
        Medium: "Medium",
        More_than_twice: "More than twice last week",
        More_than_twice_last_and: "More than twice last week and the week before",
        Highlighting_key_accomplishments: "Highlighting key accomplishments in engagement and recognition from peers and managers",
        Highly_Moderately_Somewhat_Under: "Highly, Engaged, Somewhat, Under Engaged, or In-active engagement groups are assigned based on behavioral metrics.",
        Recognized_with_a_Leadership: "Recognized with a Leadership Medal of Excellence.",
        Recognized_as_Truly_Outstanding: "Recognized as Truly Outstanding from a Peer Feedback interaction.",
        A_star_is_earned: "A star is earned when qualifying as a Star Performer, finishing in the Top 15% of recognition receivers in any given week.",
        A_score_that_represents: "A score that represents an individual's impact on the organization and the people around them, determined by",
        TEAMS: "TEAMS",
        COHORTS: "COHORTS",
        REPORT_CARD_BY_TEAM: "Report Card by Team",
        REPORT_CARD_BY_COHORTS: "Report Card by Cohort",
        Highest_Scores: "Highest Scores",
        Lowest_Score: "Lowest Score",
        Scores_are_updated_on: "Scores are updated on a quarterly basis, and can be viewed in comparison with previous scores",
        SCORE_HISTORY: "SCORE HISTORY",
        Max_Change: "Max. Change",
        Most_Recent: "Most Recent",
        NPS: "NPS",
        NPS_Details: "NPS Details",
        WHO_5: "WHO-5",
        eRes: "eRes",
        Culture: "Culture",
        DEBI: "DEBI",
        Index: "Index",
        Alignment: "Alignment",
        Variance: "Unity",
        Net_Promoter_Score_c_NPS: "Net Promoter Score ® (NPS)",
        Engagement_Score: "Engagement Score",
        Engagement_Score_is: "Dynamic Engagement Behavioral Index (DEBI) is a holistic approach to measuring employee engagement, moving beyond self-reported data to a more behaviorally anchored assessment.",
        Strategic_Alignment: "Strategic Alignment",
        Strategic_Alignment_is: "The Strategic Alignment Index measures how well teams understand and execute on priorities across four key dimensions: Understanding & Clarity, Execution & Confidence, Resource & Support, and Impact & Contribution. A higher score (0-100) indicates stronger alignment between daily work and organizational objectives. The Consistency Score reflects how uniformly this understanding is shared across team members, with higher scores indicating more consistent strategic alignment.",
        DEBI_report_card_label: "Dynamic Engagement Behavior Index measuring true engagement",
        Culture_Resilience_Well: "Culture, Resilience, Well-being Indexes",
        Net_Promotor_Score_is: "Net Promoter Score is a calculation based on promoters, passives, and detractors and range between -100 and +100.",
        Net_Promoter_Net_Promoter: "Net Promoter, Net Promoter System, Net Promoter Score, NPS and the NPS-related emoticons are registered trademarks of Bain & Company, Inc., Fred Reichheld and Satmetrix Systems, Inc.",
        A_collection_of_indexes: "A collection of indexes that provide a better understanding of your organizational culture, resilience, and well-being.",
        The_Culture_Index_is: "The Culture Index is based on measurements of behavior that indicate the strength of organizational culture.",
        The_Employee_Resilience_Index: "The Employee Resilience Index provides an indicator for the ability to bounce back from setbacks and respond to challenges.",
        The_WHO_5_Index_from: "The WHO-5 Index, from the World Health Organization, is a universal measurement for well-being.",
        Loyal_employees_who_are: "Loyal employees who are proud to work with you are your greatest assets in attracting better talent and helping overcome challenges during crisis.",
        Company_alignment_provides: "Company alignment provides managers and leaders with an understanding of how well their people are able to contribute to the company's objectives. Any mismatch is an under-utilization of resources that hinders growth, development, and engagement of the employees involved.",
        Feedback_has_significant: "Feedback has significant potential to benefit employees in terms of individual and team performance. Employees need a clear understanding of how they can improve. Continuous communication is critical",
        Recent_studies: "Recent studies",
        focus_on_how_mindset: "focus on how mindset plays a critical role in unleashing employee engagement.",
        Social_educational_and: "Social, educational, and organizational psychology illuminates how mindsets are a personal resource that may influence employees' engagement via their enthusiasm for development, construal of effort, focus of attention, perception of setbacks, and interpersonal interactions.",
        Managers_play_an_importan: "Managers play an important role in managing and shaping the mindset of their teams.",
        Employees_need_to_feel_that_they_are: "Employees need to feel that they are growing and learning at all times, both personally and professionally. Managers can play a role by being a coach and directing learning opportunities to their teams. And they also must make career development opportunities clear and transparent.",
        Employees_need_to_feel_taht_their_work: "Employees need to feel that their work is visible to others and that their effort gets the acknowledgment that it deserves. Recognition has been cited as 1 of 5 major activities that are shown to be a predictor of employee engagement.",
        The_support_that_employees: "The support that employees get from their coworkers is strongly linked to how well they are able to manage stress (wellness).",
        Studies: "Studies",
        show_that_satisfaction_with: "show that satisfaction with one's coworkers relates significantly to engagement.",
        The: "The",
        more_embedded_a_person: "more embedded a person",
        is_in_their_job: "is in their job, the less likely they are to leave it. If there are conflicts or issues among coworkers and team members, managers and leaders need to be able to act immediately.",
        Managers_set_standards_for: "Managers set standards for their team. And their direct reports want to impress them! For an effective relationship, managers should have a meaningful interaction with each direct report at least once every 2 weeks. Employees who have regular meetings with their managers are three times more likely to feel engaged in their company and thrive at their job.",
        Apart_from_pay_challenging: "Apart from pay, challenging work has been identified as the key motivator for employees. Employees need to feel that they're leading fulfilling careers and doing work that is the right fit of challenging, explained in Mihaly Csikszentmihalyi's theory of Flow - The Psychology of Optimal Experience.",
        Employees_need_work_life: "Employees need work-life balance to stay productive and engaged in their work. Studies have shown that workplace stress and burnout have a mediating effect on employee engagement. Both physical and mental wellness are considered.",
        Before: "Before",
        After: "After",
        Compare: "Compare",
        There_is_no_happiness: "There is no happiness, risk, or activity data to display (yet). Please check back tomorrow!",
        SPOTLIGHT: "Spotlight",
        Most_Engaged: "Most Engaged",
        Teams_with_highest_engagement: "Teams with highest engagement scores. The score represents an aggregate score from 9-dimensions of engagement.",
        No_most_engaged_at: "No most engaged at this time",
        Retention_Risks: "Retention Risks",
        Teams_with_highest_retention: "Teams with highest retention risk scores. The score represents an aggregate from dimensions associated with attrition.",
        No_retention_risks_at: "No retention risks at this time",
        Teams_that_show_the_most: "Teams that show the most improvement over the past 2-weeks. The score represents the change increase of engagement scores.",
        No_most_improved_at: "No most improved at this time",
        Most_Critical: "Most Critical",
        Teams_that_are_most_critical: "Teams that are most critical over the past 2-weeks. The score represents the change decrease of engagement scores.",
        Most_Improved: "Most Improved",
        No_most_critical: "No most critical at this time",
        TEAM_STATUS: "Team Status",
        Team: "Team",
        Happi_Rate: "Happi. Rate",
        Wellness: "Wellness",
        Rel_Manager: "Rel. Manager",
        Recognition: "Recognition",
        Ambassadorship: "Ambassadorship",
        Rel_Colleagues: "Rel. Colleagues",
        Personal_Growth: "Personal Growth",
        Strategic_Alignment_Details: "Strategic Alignment Details",
        Strategic_Alignment_Breakdown: "Strategic Alignment Breakdown",
        Strongly_Agree: "Strongly Agree",
        Agree: "Agree",
        Disagree: "Disagree",
        Strongly_Disagree: "Strongly Disagree",
        WHO_5_Breakdown: "WHO-5 Breakdown",
        WHO_5_Details: "WHO-5 Details",
        Culture_Index_Details: "Culture Index Details",
        Culture_Index_Breakdown: "Culture Index Breakdown",
        Scoped: "Scoped",
        Global: "Global",
        Current_Filtered_List: "Current Filtered List",
        Entire_Company: "Entire Company",
        people_impact: "People Impact",
        workplace_culture_impact: "Workplace Culture Impact",
        people_impact_tooltip_desc: "Based on behavioral analytics and individual contributions to workplace culture",
        high_impact_label: "High Impact",
        high_impact_desc: "Actively drives positive culture, recognizes others, consistently engaged",
        moderate_impact_label: "Moderate Impact",
        moderate_impact_desc: "Steady contributor, participates regularly, supports others",
        low_impact_label: "Low Impact",
        low_impact_desc: "Limited engagement, may benefit from additional support",
        people_impact_target: "Target: ≥70% combined high + moderate impact for optimal performance",
        manager_activity: "Manager Activity",
        manager_feedback_responsiveness: "Manager Feedback Responsiveness",
        manager_activity_tooltip_desc: "Based on feedback reply rates to their teams",
        manager_responsive_label: "Responsive",
        manager_responsive_desc: "Consistently replies to team feedback to keep their team engaged",
        manager_moderate_label: "Moderate",
        manager_moderate_desc: "Regular replies but may miss some feedback",
        manager_minimal_label: "Minimal",
        manager_minimal_desc: "Infrequent replies, may need coaching on feedback",
        manager_activity_target: "Target: ≥80% manager reply rate for optimal performance",
        focus_and_goal_alignment: "Focus & Goal Alignment",
        focus_alignment_tooltip: "Track how well team focus areas align with company goals.",
        focus_coverage_tooltip_bullet: "• Focus Coverage: Real-time snapshot",
        goal_alignment_tooltip_bullet: "• Goal Alignment: Last 90 days",
        learning_section_title: "Learning",
        learning_tooltip: "Track team learning and skill development progress.",
        learning_progress_tooltip_bullet: "• Learning Progress: Past 6 months",
        focus_coverage: "Focus Coverage",
        focus_areas: "Focus Areas",
        last_week: "Last week",
        people_with_focus_connector: "of",
        people_with_focus_suffix: "people have focus",
        goal_alignment: "Goal Alignment",
        goals_label: "Goals",
        aligned_suffix: "aligned",
        unaligned_suffix: "unaligned",
        unknown_label: "Unknown",
        unknown_suffix: "alignment unknown",
        setup_goals_empty_state: "Set up goals to track alignment",
        alignment_not_available: "Not enough focus data to assess alignment",
        learning_progress: "Learning Progress",
        learning_journeys: "Learning Journeys",
        members_upskilling: "members upskilling",
        completed_label: "completed",
        tenure_empty_state: "Your tenure insights will appear after your first day with Happily. This helps us show you meaningful team patterns.",
        overall_label: "Overall",
        leadership_label: "Leadership",
        pending_data: "Pending Data",
        communication_health: "Communication Health",
        show_all_teams_prefix: "Show all",
        show_all_teams_suffix: "teams",
        show_less: "Show less",
        Select: "Select",
        All_Cohorts: "All Cohorts",
        All_Teams: "All Teams",
        Search_cohorts_placeholder: "Search cohorts...",
        No_data_for_time_period: "There is no data to display for the current time period.",
        Happiness_Rate_tooltip: "The rate of \"Very Happy\" or \"Pretty Good\" responses to the \"How do you feel today?\" daily pulse question",
        Risk_Rate_tooltip: "The rate of \"Not Great\" or \"Terrible\" responses to the \"How do you feel today?\" daily pulse question",
        Avg_Impact: "Avg Impact",
        Avg_Impact_tooltip: "The average impact rating score of cohort members, calculated as the sum of their individual impact scores divided by the number of members",
        DEBI_Score: "DEBI Score",
        DEBI_Score_tooltip: "The Dynamic Engagement Behavioral Index (DEBI) for each cohort is determined by several factors: the frequency of cohort members' check-ins and responses, the quality of their feedback, their activity in recognizing peers, and their alignment with the organization's core values.",
        ENGAGEMENT_SCORE: "ENGAGEMENT SCORE",
        DEBI_by_role: "Dynamic Engagement Behavioral Index by role",
        Manager: "Manager",
        Leader: "Leader",
        Six_mo_Retention: "6-mo Retention",
        Six_mo_Retention_tooltip: "The 6-month retention rate, calculated as the percentage of cohort members who remain employed. Formula: Current Cohort Size ÷ (Current Cohort Size + Employees Archived in Last 6 Months) × 100",
        ARCHIVED_MEMBERS_HISTORY: "ARCHIVED MEMBERS HISTORY",
        Number_of_archived_by_month: "Number of archived members by month",
        Terminated: "Terminated",
        Resigned: "Resigned",
        Preparing_cohort_data: "Preparing cohort data, please wait...",
        Organizational_Network: "Organizational Network",
        Organizational_Network_desc: "Visualizing connections formed through peer/manager recognition, feedback exchanges, and meaningful interactions over the past 6 months",
        Focusing: "Focusing",
        Nodes: "Nodes",
        Attribute: "Attribute",
        Links: "Links",
        Relationships: "Relationships",
        Relationship_Attributes: "Relationship Attributes",
        Relationship_Power: "Relationship Power",
        Filter_by_power_rating: "Filter by power rating classification groups",
        Signature: "Signature",
        Filter_by_signature: "Filter by the signature value tagged in the relationships",
        Connections: "Connections",
        Engagement: "Engagement",
        Signatures: "Signatures",
        Name_Team: "Name, Team",
        No_signatures_available: "No signatures available",
        All_Signatures: "All Signatures",
        more_suffix: "more",
        Focus_in_relationship_map: "Focus in relationship map",
        Total: "Total",
        Manager_Responsiveness: "Manager Responsiveness",
        Manager_Activity_Details: "Manager Activity Details",
        Managers_play_central_role: "Managers play a central role in linking your objectives to actions and results.",
        Performance_Metrics: "Performance Metrics",
        Feedback_Rate: "Feedback Rate",
        Reply_Rate: "Reply Rate",
        Performance_Boosts_On_Track: "Performance Boosts On Track",
        Insights_and_Nudges: "Insights & Nudges",
        Daily_Insights: "Daily Insights",
        Weekly_Insights: "Weekly Insights",
        Coaching_Suggestions: "Coaching Suggestions",
        Coaching_Suggestions_desc: "AI-generated action items sent to managers in their weekly reports over the past 4 weeks. These personalized recommendations help managers improve team engagement and performance.",
        Individual_Manager_Analysis: "Individual Manager Analysis",
        Manager_Scorecard: "Manager Scorecard",
        Manager_Scorecard_desc: "This scorecard provides an overview of the key activities and performance metrics for managers, focusing on their interactions with direct reports. It helps understand how well managers role model key behaviors, drive performance, and engage their teams.",
        Manager_Scorecard_definition: "Manager effectiveness, 0–100. A weighted score of the leadership behaviors and team outcomes your company values most.",
        Scorecard_Settings: "Scorecard settings",
        Performance_reviews_enabled: "Performance reviews enabled",
        Category_Weights: "Category weights",
        Advanced_weights: "Advanced: weight individual metrics",
        Show_composite_as: "Show composite as",
        Save_settings: "Save settings",
        Reset: "Reset",
        Performance_Group: "Performance Group",
        All_Performance_Groups: "All Performance Groups",
        Elite_Managers: "Elite Managers",
        High_Performers: "High Performers",
        Rising_Stars: "Rising Stars",
        Feedback_Champions: "Feedback Champions",
        At_Risk_Managers: "At-Risk Managers",
        Ghost_Managers: "Ghost Managers",
        Conv_Initiated: "Conv. Initiated",
        Conv_Initiated_tooltip: "Percentage of conversations initiated by this manager with their own manager, demonstrating proactive upward communication",
        Peer_Feedback: "Peer Feedback",
        Peer_Feedback_tooltip: "Number of peer feedback requests this manager has made for themselves, showing commitment to self-improvement",
        Boosts_On_Track: "Boosts On Track",
        Boosts_On_Track_tooltip: "Percentage of performance boosts that are either completed or pending but not overdue",
        Goals_Progress: "Goals Progress",
        Goals_Progress_tooltip: "Overall progress made by direct reports as evaluated in their performance reviews",
        Culture_Contr: "Culture Contr.",
        Culture_Contr_tooltip: "How well direct reports are contributing to the culture, as evaluated in their performance reviews",
        Reply_Rate_tooltip: "Percentage of team feedback the manager has responded to in the past 30 days",
        Reply_Rate_short: "Reply Rate",
        Reply_Rate_line1: "Reply",
        Reply_Rate_line2: "Rate",
        Insights_Opened_tooltip: "Percentage of Manager Insights opened from email inbox. Note: May be inaccurate if email tracking is blocked",
        Insights_Opened_short: "Insights Opened",
        Team_DEBI: "Team DEBI",
        Team_DEBI_line1: "Team",
        Team_DEBI_line2: "DEBI",
        DEBI_Score_col_tooltip: "Dynamic Engagement Behavior Index for this manager's team, based on their direct reports. This is a DEBI behavior index, so it can differ from the People Intelligence Engagement composite score.",
        Action_Items_line1: "Action",
        Action_Items_line2: "Items",
        Manager_Coaching_Interactions: "Manager Coaching Interactions",
        Manager_Classification_Settings: "Manager Classification Settings",
        View_detailed_breakdown: "View detailed breakdown",
        Proactivity_Rating_Breakdown: "Proactivity Rating Breakdown",
        Psychological_Safety_Breakdown: "Psychological Safety Breakdown",
        People_Risk_Recovery_Trends: "People Risk & Recovery Trends",
        Click_any_week_for_details: "Click any week to see details",
        Recovery: "Recovery",
        AVG: "AVG",
        Percentile: "Percentile",
        Name_and_Team: "Name and Team",
        Health_Indicator: "Health Indicator",
        Contributions: "Contributions",
        Talent_and_Network: "Talent & Network",
        Organizational_Positioning: "Organizational Positioning",
        Medals_and_Peer_Ratings: "Medals & Peer Ratings",
        Skills_and_Values: "Skills & Values",
        Overall_Score: "Overall Score",
        col_name_team_tooltip: "Employee name, department, and current wellness status based on recent feedback",
        col_contributions_tooltip: "Recognition from peers and performance evaluation by managers",
        col_talent_network_tooltip: "Employee's talent classification and organizational network reach",
        col_achievements_tooltip: "Recognitions earned through medals and high peer feedback ratings",
        col_alignment_tooltip: "Assessment of employee's proficiency in key skills and alignment with company values",
        col_impact_rating_tooltip: "Overall performance score with weekly change indicator",
        Support: "Support",
        Performance: "Performance",
        Performance_subtitle: "KR or gem rate",
        Performance_subtitle_v2: "Goals & feedback",
        Performance_subtitle_kr: "KR · {progress}%",
        Performance_subtitle_gem: "Gem rate",
        Performance_dataNote_kr: "Average of KR progress and KR health for the goals this person owns.",
        Performance_dataNote_gem: "Gem rate (culture and goals both rated 3+) weighted by number of interactions. Based on last 6 months.",
        Happiness: "Happiness",
        Happiness_subtitle: "Daily check-ins",
        Happiness_dataNote: "Daily happiness response patterns from check-ins. Reflects recent mood. Distinct from Wellbeing, which uses the WHO-5 Index.",
        Wellbeing: "Well-being",
        Wellbeing_subtitle: "WHO-5 score",
        Wellbeing_dataNote: "Quarterly well-being measurement based on WHO-5. Daily happiness is still shown as the health indicator.",
        Impact_Rating_dataNote: "Overall contribution composite. Combines engagement behavior and organizational impact. Updated weekly. Scores above 70 indicate strong engagement.",
        Engagement_subtitle: "Past 30 days",
        Flight_Risk: "Flight Risk",
        Flight_Risk_subtitle: "90-day signal",
        Flight_Risk_Low: "Low",
        Flight_Risk_Moderate: "Moderate",
        Flight_Risk_High: "High",
        Flight_Risk_Safe: "Safe",
        Flight_Risk_Watch: "Watch",
        Flight_Risk_At_risk: "At risk",
        Flight_Risk_dataNote: "Builds from red (unhappy) daily check-in patterns over the last 90 days. Higher number means greater disengagement risk.",
        Peer_Trust: "Peer Trust",
        Peer_Trust_subtitle_short: "Trust · peers",
        Peer_Trust_subtitle_v2: "Trust · network",
        Peer_Trust_dataNote: "Combines peer feedback activity, recognition reciprocity, network depth, and recognition quality. Based on last 6 months.",
        Peers: "peers",
        Band_Excellent: "Excellent",
        Band_Good: "Good",
        Band_Fair: "Fair",
        Band_Watch: "Watch",
        Band_Poor: "Poor",
        No_data: "No data",
        Performance_no_reviews: "No reviews",
        Recognized_By: "Recognized by",
        Recognized_as_outstanding_by: "Recognized as Outstanding by",
        Recognized_as_outstanding: "Recognized as Outstanding",
        Peer_single: "peer",
        Past_6_mo: "past 6 mo",
        Past_6_months: "past 6 months",
        Medals: "Medals",
        Giving: "Giving",
        Receiving: "Receiving",
        Vs_team_median_6mo: "vs team median (6 mo)",
        Band_top_quartile: "Top 25%",
        Band_above_median: "Above avg",
        Band_typical: "Typical",
        Band_below_typical: "Below avg",
        Truly_Outstanding: "Truly Outstanding",
        Exceeding_Expectations: "Exceeding Expectations",
        Skill_band_developing: "Developing",
        Skill_band_building: "Building",
        Skill_band_applying: "Applying",
        Skill_band_integrated: "Integrated",
        Skill_band_mastery: "Mastery",
        Values_band_strong: "Strong alignment",
        Values_band_aligned: "Aligned",
        Values_band_mixed: "Mixed",
        Values_band_emerging: "Emerging",
        Values_split_given_label: "Given",
        Values_split_received_label: "Received",
        Values_tooltip_intro: "AI-analyzed from peer recognition activity.",
        Values_tooltip_events_suffix: "recognition events (past 60 days)",
        Not_measured: "Not measured",
        More: "more",
        Coins: "coins",
        Gems: "gems",
        Engagement: "Engagement",
        Checkin_consistency: "Check-in consistency",
        Giving_recognition: "Giving recognition",
        Receiving_recognition: "Receiving recognition",
        Manager_responsiveness: "Manager responsiveness",
        No_manager_assigned: "No manager assigned",
        Risk_reason: "Risk reason",
        Goals: "Goals",
        Power_Skills: "Power Skills",
        Empathy: "Empathy",
        Self_Awareness: "Self-Awareness",
        Critical_Thinking: "Critical Thinking",
        Leadership: "Leadership",
        Initiative: "Initiative",
        Optimism: "Optimism",
        Positioning_and_Achievements: "Positioning & Achievements",
        Engagement_and_Contributions: "Engagement & Contributions",
        Context_and_Power_Skills: "Context & Power Skills",
        Show_details_for: "Show details for {name}",
        col_happiness_tooltip: "Daily happiness response patterns from check-ins. WHO-5 shown as the canonical wellbeing benchmark when available.",
        col_wellbeing_tooltip: "Quarterly well-being measurement based on the latest completed WHO-5 score.",
        col_engagement_tooltip: "Individual score based on the same behavior model as DEBI: pulse response, open feedback participation, feedback effort, recognition participation, and values-aligned recognition.",
        col_flight_risk_tooltip: "Disengagement likelihood based on unhappy check-in patterns over the last 90 days.",
        col_performance_tooltip: "KR progress when goals are owned; otherwise the peer-rated gem rate from recognition.",
        col_peer_trust_tooltip: "How trusted and valued someone is by peers, plus the breadth of peer relationships.",
        Engagement_dataNote: "Combines 6 monthly indicators: daily check-ins (30%), open-ended feedback (20%), recognition activity (20%), manager feedback (10%), recognition quality (10%), and peer feedback (10%). Based on the most recent month.",
        Skills: "Skills",
        Values: "Values",
        Values_Alignment: "Values Alignment",
        Talent_Group: "Talent Group",
        All_People: "All People",
        risk_drilldown: {
            title: "Risk Drill-Down",
            high: "High",
            med: "Med",
            low: "Low",
            recovered: "Recovered",
            recovered_lc: "recovered",
            no_change: "No change",
            selected: "Selected",
            col_name: "Name",
            col_frequency: "Frequency",
            col_history: "History",
            exited: "Exited",
            weeks_short: "/ 8 wks",
            at_risk: "at risk",
            week_of: "Week of",
            recurring: "Recurring",
            first_time: "First Time",
        },
        spotlight: {
            highlighting_teams: "Highlighting teams worth focusing on for the week of",
            most_engaged: "MOST ENGAGED",
            most_engaged_desc: "Teams with highest engagement scores. The score represents an aggregate score from 9-dimensions of engagement.",
            retention_risks: "RETENTION RISKS",
            retention_risks_desc: "Teams with highest retention risk scores. The score represents an aggregate from dimensions associated with attrition.",
            most_improved: "MOST IMPROVED",
            most_improved_desc: "Teams that show the most improvement over the past 2-weeks. The score represents the change increase of engagement scores.",
            most_critical: "MOST CRITICAL",
            most_critical_desc: "Teams that are most critical over the past 2-weeks. The score represents the change decrease of engagement scores.",
            team: "Team",
            score: "Score",
        },
    },
    goals: {
        team_goals: "Team Goals",
        goals_description: "Manage and track goals for each team",
        add_goals: "Add Goals",
        edit_goals: "Edit Goals",
        save: "Save",
        cancel: "Cancel",
        team_name: "Team",
        goals_label: "Team Goals",
        goals_placeholder: "Enter team goals and objectives, one per line...",
        goals_hint: "These goals will be used to provide targeted analysis and feedback guidance for managers and their teams.",
        add_goals_title: "Add Team Goals",
        edit_goals_title: "Edit Team Goals",
        no_teams: "No teams found",
        no_goals: "No goals set",
        save_success: "Goals saved successfully",
        save_error: "Error saving goals. Please try again.",
        kr_templates: {
            revenue_mrr_title: "Increase monthly recurring revenue",
            revenue_mrr_reasoning: "Revenue-focused goal suggests tracking monetary growth as a measurable outcome.",
            revenue_deals_title: "Close new deals this quarter",
            revenue_deals_reasoning: "Deal count provides a leading indicator of revenue growth.",
            revenue_deal_size_title: "Improve average deal size",
            revenue_deal_size_reasoning: "Larger deals compound revenue growth without requiring proportional effort increase.",
            customer_nps_title: "Achieve target NPS score",
            customer_nps_reasoning: "NPS directly measures customer satisfaction and loyalty.",
            customer_churn_title: "Reduce customer churn rate",
            customer_churn_reasoning: "Lower churn signals improved customer experience and retention.",
            customer_support_title: "Increase support ticket resolution speed",
            customer_support_reasoning: "Faster resolution directly impacts customer satisfaction.",
            hire_fill_title: "Fill open positions",
            hire_fill_reasoning: "Tracking headcount progress against hiring plan.",
            hire_time_title: "Reduce time-to-hire",
            hire_time_reasoning: "Faster hiring improves team velocity and reduces opportunity cost.",
            hire_retention_title: "New hire 90-day retention rate",
            hire_retention_reasoning: "High early retention signals effective onboarding and role fit.",
            ship_features_title: "Ship planned features on time",
            ship_features_reasoning: "Feature delivery count tracks execution against product roadmap.",
            ship_bugs_title: "Reduce bug escape rate to production",
            ship_bugs_reasoning: "Lower escape rate indicates improved quality before release.",
            ship_adoption_title: "Achieve user adoption of new features",
            ship_adoption_reasoning: "Adoption validates that shipped features solve real user needs.",
            engage_score_title: "Improve team engagement score",
            engage_score_reasoning: "Engagement score reflects overall team health and motivation.",
            engage_participation_title: "Increase participation in feedback",
            engage_participation_reasoning: "Higher participation rates indicate psychological safety and engagement.",
            engage_turnover_title: "Reduce voluntary turnover",
            engage_turnover_reasoning: "Lower turnover signals improved culture and employee satisfaction.",
            generic_milestones_title: "Complete key milestones",
            generic_milestones_reasoning: "Milestone tracking provides clear progress checkpoints for this objective.",
            generic_completion_title: "Achieve target completion rate",
            generic_completion_reasoning: "Overall completion percentage gives a single view of goal progress.",
            generic_improvement_title: "Deliver measurable improvement",
            generic_improvement_reasoning: "Quantifying improvement makes progress visible and motivating.",
            unit_deals: " deals",
            unit_hires: " hires",
            unit_days: " days",
            unit_features: " features",
            unit_milestones: " milestones",
            unit_percent_within_sla: "% within SLA",
            unit_percent_of_users: "% of users",
        },
    },
    integrations: {
        API_DOCUMENTATION: "API DOCUMENTATION",
        Reference_and_instructional: "Reference and instructional guides on available API actions",
        Go_to_API_Doc: "Go to API Doc",
        PRODUCTION_TOKEN: "PRODUCTION TOKEN",
        This_is_your_production: "This is your production token. Your API tokens need to be treated as securely as any other password.",
        Generate_a_Token: "Generate a Token",
        API_LOG: "API LOG",
        A_log_of_API_activity: "A log of API activity created by the API token associated with your account that details the date, API operation, status, and deployment type of the API transaction.",
        results_from: "results from",
        results: "results",
        SELECT_SYNC_METHOD: "SELECT SYNC METHOD",
        INTEGRATION_PARAMETERS: "INTEGRATION PARAMETERS",
        Webhook: "Webhook",
        Sort_by_Name: "Sort by Name",
        Token: "Token",
        Webhook_Endpoint: "Webhook Endpoint",
        Sync_Type: "Sync Type",
        Staged_Syncing: "Staged Syncing",
        Your_members_are_queued_up: "Your members are queued up and prepared for addition or deactivation. This method provides you with a chance to manually review changes before they're implemented",
        Normal_Syncing: "Normal Syncing",
        Users_can_be_added: "Users can be added to Happily directly, and will be automatically added or deactivated based on their status in your submitted data",
        Syncing: "Syncing",
        All_users_who_are: "All users who are in Happily, but not in the submitted data, will be deactivated",
        Options: "Options",
        Abbreviate_Team_Name: "Abbreviate Team Name",
        Automatically_abbreviate_long_team: "Automatically abbreviate long team names to make reports and insights more readable",
        Enable: "Enable",
        Enable_web_hook: "Enable web hook",
        Any_data_that: "Any data that you submit to the web hook will be synced with your network",
        Save_Changes: "Save Changes",
        WEBHOOK_LOGS: "WEBHOOK LOGS",
        Sync_users_using_your: "Sync users using your HRIS. This list contains the latest 50 HRIS Webhook requests. You can",
        Simulate_Changes: "Simulate Changes",
        to_see_how_the: "to see how the data would affect your network using your current HRIS Webhook sync settings",
        Date: "Date",
        Webhook_Content: "Webhook Content",
        Integration_Status: "Integration Status",
        Actions: "Actions",
        View_Changes: "View Changes",
        No_webhook_activity: "No webhook activity recorded",
        Members: "Members",
        INTEGRATION_STATUS: "INTEGRATION STATUS",
        HRIS_Sync: "HRIS Sync",
        Sync_your_employee_data: "Sync your employee data with your HRIS a single flow member management",
        Connected: "Connected",
        Setup: "Setup",
        Developer_API: "Developer API",
        Activate_your_developer: "Activate your developer program and get credentials to access API services",
        SSO_Title: "Single Sign-On (SSO)",
        SSO_Desc: "Enable SSO as the authentication and provisioning method for member accounts",
        Directory_Sync: "Directory Sync",
        Endpoint: "Endpoint",
        Enable_Directory_Sync: "Enable Directory Sync",
        Directory_Sync_Desc: "Any data that submitted by your directory will be synced with your Happily account",
        slack: {
            loadingConfig: "Loading Slack configuration...",
            connectTitle: "Connect Happily to Slack",
            connectDescription: "Bring recognition, insights, and engagement directly into your team's Slack workspace.",
            feature: {
                recognitionTitle: "Recognition Broadcasting",
                recognitionDesc: "Automatically share recognition in Slack channels",
                reportsTitle: "Manager Report Snippets",
                reportsDesc: "Daily and weekly insights delivered via DM",
                nudgesTitle: "Check-in Nudges",
                nudgesDesc: "Gentle reminders to encourage participation",
                reactionTitle: "Reaction Sync",
                reactionDesc: "Slack reactions sync back to Happily",
            },
            connecting: "Connecting...",
            connectButton: "Connect to Slack",
            redirectNote: "You'll be redirected to Slack to authorize Happily",
            comingSoon: "Slack integration backend is being set up. Check back soon!",
            connectedTo: "Connected to",
            connectedOn: "Connected",
            byUser: "by",
            test: "Test",
            disconnect: "Disconnect",
            featuresSection: "Features",
            toggle: {
                recognitionDesc: "Post recognition to Slack channels",
                dailyReportTitle: "Daily Report Snippets",
                dailyReportDesc: "Morning insights for managers",
                weeklyReportTitle: "Weekly Report Snippets",
                weeklyReportDesc: "Weekly summaries on Mondays",
                nudgesDesc: "Encourage participation with gentle reminders",
                reactionDesc: "Track Slack reactions in Happily",
            },
            channelSettings: "Channel Settings",
            recognitionChannel: "Recognition Channel",
            selectChannel: "Select a channel",
            teamChannels: "Also post to team-specific channels",
            dmRecipients: "DM recipients directly",
            nudgeSettings: "Nudge Settings",
            triggerAfter: "Trigger after",
            daysWithoutCheckin: "days without check-in",
            maxPerWeek: "Max per week",
            nudgesPerPerson: "nudges per person",
            saving: "Saving...",
        },
        sso: {
            selectMethod: "SELECT SSO METHOD",
            general: "GENERAL",
            providerId: "SSO Provider ID",
            providerIdPlaceholder: "Provider ID",
            connectionName: "Connection name",
            connectionNamePlaceholder: "Logical identifier of the connection",
            entityId: "Entity ID",
            signInUrl: "Sign In URL",
            certificate: "Certificate",
            certificatePlaceholder: "SAMLP server public key encoded in PEM or CER format",
            syncProfileAttributes: "Sync Profile Attributes",
            syncAtLogin: "Sync user profile attributes at each login",
            syncAtLoginDesc: "Updates first name, last name, and profile photo data at each login event",
            setupInfo: "SETUP INFO",
            authCallbackUrl: "Auth Callback URL",
            on: "ON",
            off: "OFF",
            ssoEnabledLabel: "SSO is enabled as the sign-on method",
            dangerZone: "DANGER ZONE",
            deleteConnection: "Delete Connection",
            deleteConnectionDesc: "Once confirmed, this operation can't be undone! Member login will revert to OTP.",
            removeConnection: "Remove this connection",
        },
    },
    login: {
        sign_in_to: "Sign in to",
        please_enter_your: "Please enter your email address",
        keep_me_logged: "Keep me logged in",
        terms_and_Conditions: "Terms & Conditions",
        sign_in: "Sign in",
        your_account_access: "Your account access is blocked, outside valid access parameters",
        your_IP: "Your IP",
    },
    members: {
        ORGANIZATION_CHART_VIEW: "ORGANIZATION CHART VIEW",
        the_org_chart: "The org chart in its current view is too large to export as an image file.",
        Members: "Members",
        incomplete_profiles: "incomplete profiles",
        Archived: "Archived",
        ADD_MEMBER: "ADD MEMBER",
        EXPORT_ALL: "EXPORT ALL",
        REVIEW_UPDATES: "REVIEW UPDATES",
        members_selected: "members selected",
        RE_ASSIGN_MANAGER: "RE-ASSIGN MANAGER",
        EDIT_TEAM: "EDIT TEAM",
        ADD: "ADD",
        EDIT: "EDIT",
        ARCHIVE: "ARCHIVE",
        SEND_INVITE: "SEND INVITE",
        RE_ASSIGN: "RE-ASSIGN",
        IGNORE: "IGNORE",
        Invited: "Invited",
        Active: "Active",
        Inactive: "Inactive",
        All: "All",
        New: "New",
        Team: "Team",
        Member: "Member",
        Assign_Team: "Assign Team",
        Assign_Manager: "Assign Manager",
        Coins: "Coins",
        Gems: "Gems",
        Permission: "Permission",
        Status: "Status",
        results_from: "results from",
        results: "results",
        coins: "coins",
        gems: "gems",
        years: "years",
        months: "months",
        days_ago: "days ago",
        joined_after: "joined after",
        Joined: "Joined",
        Daily_Streak: "Daily Streak",
        Achievements: "Achievements",
        Super_Feedback: "Super Feedback",
        Problem_Areas: "Problem Areas",
        MOST_RECENT: "MOST RECENT",
        Powers: "Powers",
        Badges: "Badges",
        Knowledge: "Knowledge",
        Initiative: "Initiative",
        Contributor: "Contributor",
        Leadership: "Leadership",
        Health: "Health",
        Org: "Org",
        Relationships: "Relationships",
        Are_you_sure_would: "Are you sure would like to Archive this member?",
        Once_archived_the_member: "Once archived, the member will be automatically logged out of Happily and will not be able to login again.",
        Archived_members_can_be: "Archived members can be restored at a later time.",
        CANCEL: "CANCEL",
        First_Name: "First Name",
        Last_Name: "Last Name",
        Email: "Email",
        Manager: "Manager",
        Select_a_Manager: "Select a Manager",
        Select_a_Team: "Select a Team",
        will_be_created_as_a: "will be created as a new team",
        User_role: "User role",
        emoji_Member: "👩🏻 Member",
        Limited_Access: "Limited Access",
        emoji_Admin: "✍🏻  Admin",
        integrations: "Integrations",
        Manage_Account_Email_Notifications: "Manage Account, Email Notifications",
        emoji_HR: "👩🏻‍💻  HR",
        Manage_Account_Insights: "Manage Account, Insights",
        emoji_Leader: "👩🏻‍💼 Leader",
        Insights_Medals: "Insights, Medals",
        emoji_Super_Leader: "🦸🏻‍♀️ Super Leader",
        Manage_Account_Insights_Medals: "Manage Account, Insights, Medals",
        emoji_Super_Admin: "🙆🏻‍♀️ Super Admin",
        Manage_Account_Insights_Email: "Manage Account, Insights, Email Notifications",
        Language: "Language",
        Country: "Country",
        English: "English",
        Thai: "Thai",
        BahasaMalay: "Bahasa Malay",
        ChineseHK: "Chinese (Traditional, Hong Kong)",
        BrazilianPortuguese: "Brazilian Portuguese",
        Burmese: "Burmese",
        SAVE_CHANGES: "SAVE CHANGES",
        Automatically_send_an: "Automatically send an invitation email to the new member",
        Archive_employee: "Archive employee",
        Archived_Type: "Archived Type",
        Direct_Reports: "Direct Reports",
        Re_Assign_Manager: "Re-Assign Manager",
        Search_manager_name: "Search manager name",
        Suggestions_based_on_member: "Suggestions based on member selection or search field",
        SUBMIT: "SUBMIT",
        Archived_Employee: "Archived Employee",
        Edit_Team: "Edit Team",
        Edit_Manager: "Edit Manager",
        members: "members",
        Top_Most: "Top Most",
        UNARCHIVE: "UNARCHIVE",
        DELETE: "DELETE",
        delete_all: "delete all",
        Unarchive: "Unarchive",
        Delete: "Delete",
        Search_team_name: "Search team name",
        Complete_manager_assignment: ">Complete manager assignment",
        is_missing_a_direct: "is missing a direct manager. Please select a manager to secure line of management.",
        SELECT_DIRECT_MANAGER: "SELECT DIRECT MANAGER",
        Re_assign_a_manager: "Re-assign a manager to replace",
        the_archived_manager: "the archived manager",
        has_been_archived_leaving: "has been archived, leaving",
        members_without_a_direct: "members without a direct manager. Please re-assign a manager to secure line of management.",
        Teams: "Teams",
        powers: "powers",
        CREATE_TEAM: "CREATE TEAM",
        badges: "badges",
        Information: "Information",
        Sort_by_Direct_Reports: "Sort by Direct Reports",
        duplicate_teams: "duplicate teams",
        Sort_by_Name: "Sort by Name",
        ADD_TEAM: "ADD TEAM",
        Sort_by_Parent: "Sort by Parent",
        Team_Manager: "Team Manager",
        Parent_Team: "Parent Team",
        Team_Name: "Team Name",
        Auto_assignment: "Auto-assignment",
        Color_Tag: "Color Tag",
        A_unique_team_name: "A unique team name is required",
        A_parent_team_and: "A parent team and manager will be auto-assigned based on the team members’ relationships with managers",
        Select_a_color_tag: "Select a color tag to visually organize your teams For example, by business unit/vertical",
        No_team_members: "No team members",
        Managers: "Managers",
        Search: "Search",
        managers_selected: "managers selected",
        Cohorts: "Cohorts",
        CREATE: "CREATE",
        duplicate_cohorts: "duplicate cohorts",
        ADD_COHORT: "ADD COHORT",
        Cohort_Name: "Cohort Name",
        Select_Member: "Add by name, email, or team",
        Select_Leaders: "Assign leader by name (optional)",
        Auto_generated: "Auto-generated",
        Bulk_add_by_inputing: "Bulk add by inputting comma separated email addresses",
        Add_members_to_this: "Add members to this cohort",
        No_Cohort_members: "No Cohort members",
        Cohort_Leader: "Cohort Leaders",
        Leader_description: "Cohort leaders receive daily and weekly insights",
        Cohort_Type: "Cohort Type",
        Manual: "Manual",
        Dynamic: "Dynamic",
        Configure_Dynamic_Rules: "Configure Dynamic Rules",
        Dynamic_cohort_description: "Members will be automatically added or removed based on the rules you configure below.",
        Preview: "Preview",
        Please_add_at_least_one_valid_rule: "Please add at least one valid rule for dynamic cohort.",
        Error_previewing_cohort: "Error previewing cohort. Please try again.",
        No_members_match: "No members match the current rules",
        team_audit: {
            title: "Team Relationship Audit",
            teams_analyzed: "teams analyzed",
            discrepancies_found: "discrepancies found",
            analyzing: "Analyzing team relationships...",
            all_valid: "All team parent-child relationships are valid!",
            fix: "Fix",
            manual_review_tooltip: "Cannot automatically fix - requires manual review",
            manual_review: "Manual Review",
            team_manager: "Team Manager",
            multiple_managers: "Multiple Managers",
            unassigned: "Unassigned",
            managers_boss: "Manager's Boss",
            no_boss_top_level: "No Boss (Top Level)",
            team_hierarchy: "Team Hierarchy",
            current_structure: "Current Structure",
            recommended: "Recommended",
            no_parent_team: "No parent team",
            should_have_no_parent: "Should have no parent",
            new_badge: "NEW",
            fix_all_issues: "Fix All Issues",
            rerun_audit: "Re-run Audit",
            failed_run: "Failed to run audit",
            fixed_relationship_for: "Fixed parent relationship for",
            failed_fix: "Failed to fix",
            fixed_prefix: "Fixed",
            fixed_suffix: "team relationships",
            some_failed: "Some relationships could not be fixed",
        },
        search_by_name_or_team: "Search by name or team",
        preparing_org_chart_download: "Preparing the org chart for download, please wait...",
        cohorts: {
            main_conditions: "Main Conditions",
            nested_group: "Nested Group",
            members_must_match: "Members must match",
            add_rules_or_groups_below: "Add rules or groups below",
            add_rule: "Add Rule",
            add_group: "Add Group",
            select_attribute: "Select attribute",
            select_operator: "Select operator",
            select_value: "Select value",
            select_values: "Select values",
            type_to_search: "Type to search",
            min: "Min",
            max: "Max",
            and: "and",
        },
        relationship_mapping: {
            outer_network: "Outer Network",
            inner_network: "Inner Network",
        },
        profile: {
            view_personal_context: "View Personal Context",
            download_photo: "Download Photo",
            personal_context_suffix: "'s Personal Context",
            personal_context_subtitle: "Analysis from communication patterns and feedback to understand them at a deeper level.",
            personal_values: "Personal Values",
            skills_competencies: "Skills & Competencies",
            personality_communication: "Personality & Communication",
            personality_traits: "PERSONALITY TRAITS",
            communication_style: "COMMUNICATION STYLE",
            role_focus: "Role Focus",
            recent_challenges: "Recent Challenges",
            activity_timeline: "Activity Timeline",
            loading_happiness_data: "Loading happiness data...",
            happiness_history_90d: "90-Day Happiness History",
            recent_happiness_suffix: "'s recent happiness",
            happy_label: "Happy:",
            okay_label: "Okay:",
            not_great_label: "Not Great:",
            recovery_progress: "Recovery Progress",
            risk_flags_summary: "Risk Flags Summary",
            recent_timeline_label: "Recent Timeline (oldest to newest):",
            no_response: "No response",
            happy: "Happy",
            okay: "Okay",
            not_great: "Not Great",
            hover_load_happiness: "Hover to load happiness data",
            happiness_icon_title: "View 90-day happiness journey with risk & recovery insights",
            star_performance_tooltip: "Star performance from being in the top 15% of people who received recognition that week",
            no_recent_data: "No recent data",
            top_skills: "Top Skills",
            top_skills_subtitle: "unique peer feedback endorsements",
            culture_add: "Culture Add",
            culture_add_subtitle: "contributions to recognition #values",
            view_all: "View all",
            recognition_given: "Recognition Given",
            recognition_received: "Recognition Received",
            give_to_receive_ratio: "Give-to-receive Ratio",
            alignment_rating_score: "Alignment Rating Score",
            is_a_top: "is a top",
            culture_add_contributor_suffix: "% culture add contributor",
        },
    },
    pincode: {
        your_verification: "Your verification",
        enter_the_four: "Enter the 4-digit code sent to your inbox",
        your_code_is: "Your code is incorrect. Please try again…",
        you_have: "You have",
        attempts_remaining: "attempts remaining",
    },
    powerUp: {
        EXPORT: "EXPORT",
        Recognition_trends: "Recognition trends",
        PARTICIPATION_RATE: "PARTICIPATION RATE",
        No_Filter: "No Filter",
        Select_all: "Select all",
        Clear: "Clear",
        Filter_power_up: "Filter power-up activity based on recognition values",
        Cancel: "Cancel",
        Okay: "Okay",
        results_from: "results from",
        results: "results",
        Export_Power_up_Activity: "Export Power-up Activity",
        Date_Range: "Select a Start and End Date",
        Start_Date: "Start Date",
        End_Date: "End Date",
        Recipient: "Recipient(s)",
        From: "From",
        For: "For",
        Reward: "Reward",
        Sent_on: "Sent on",
        Automations: "Automations",
        Preset_Library: "Preset Library",
        By_Month: "By Month",
        Automate: "Automate",
        By_Quarter: "By Quarter",
        By_Year: "By Year",
        Create_your_own: "Create your own",
        Recognition: "Recognition",
        Power_up_Recipients: "Power-up Recipients",
        based_on_your_selection: "based on your selection",
        Preview_on_Mobile_Layout: "Preview on Mobile Layout",
        got: "got",
        for: "for",
        This_power_up_automation_has: "This power-up automation has not been activated",
        This_power_up_automation_has_been: "This power-up automation has been activated",
        Recipients: "Recipients",
        recipients: "recipients",
        Autogenerated: "Autogenerated",
        for_showing_time_period: "for showing time period",
        Add: "Add",
        Values_optional: "Values (optional)",
        Select_values_optional: "Select values (optional)",
        Schedule: "Schedule",
        Following_work_day: "Following work day",
        Time: "Time",
        Select_time: "Select time",
        Now: "Now",
        Name_of_Recipient: "Name of Recipient",
        Name_of_Recipient_s: "Name of Recipient(s)",
        Reason_for_recognition: "Reason for recognition",
        Reward_Type: "Reward Type",
        Medal_Design: "Medal Design",
        Coin_Medal_or_Gem: "Coin, Medal, or Gem",
        Amount: "Amount",
        Number_of_coins: "Number of coins",
        Number_of_gems: "Number of gems",
        Share_on_Activity_Feed: "Share on Activity Feed",
        SAVE_CHANGES: "SAVE CHANGES",
        DE_ACTIVATE_AUTOMATION: "DE-ACTIVATE AUTOMATION",
        ACTIVATE_AUTOMATION: "ACTIVATE AUTOMATION",
        SEND: "SEND",
        RESET: "RESET",
        Duplicate: "Duplicate",
        Delete: "Delete",
        performance: {
            select_teams: "Select Teams",
            select_time_period: "Select Time Period",
            performance_presets: "Performance Presets",
            performance_tracker: "Performance Tracker",
            boosts_status: "Boosts Status",
            culture_add: "Culture Add",
            goal_progress: "Goal Progress",
            active_filter: "Active Filter",
            clear_filter: "Clear Filter",
            export: "Export",
            no_matching_results: "No matching results found",
            no_matching_results_desc: "We couldn't find any data that matches your current filter selections.",
            try_one_of_these: "Try one of these:",
            clear_all_filters: "Clear All Filters",
            manager: "Manager",
            boosts_on_track: "Boosts On Track",
            both: "Both",
            team_member: "Team Member",
            goal_follow_up: "Goal Follow-up",
            per_goal_ratings: "Per-Goal Ratings",
            culture_follow_up: "Culture Follow-up",
            preset_name: "Preset Name",
            review_questions: "Review Questions",
            goal_performance: "Goal Performance",
            culture_contribution: "Culture Contribution",
            scheduling: "Scheduling",
            next_review_period: "Next Review Period",
            assignments: "Assignments",
            assign_to_teams: "Assign to Teams",
            assign_members: "Assign Members",
            boost_preview: "Boost Preview",
        },
        activity: {
            total_recognition: "Total Recognition",
            value_aligned: "Value-Aligned",
            pct_value_aligned: "% Value-Aligned",
            participation_rate: "Participation Rate",
            recognition_trends: "Recognition trends",
            last_12_months: "Last 12 months",
            total: "Total",
            values_aligned_hash: "#Values-aligned",
            values_heatmap: "Values Heatmap",
            show_all: "Show All",
            use: "Use",
            window: "window",
            values: "Values",
            recognition_trends_data: "Recognition Trends Data",
            month: "Month",
            values_aligned: "Values-Aligned",
            pct_values_aligned: "% Values-Aligned",
            export_csv: "Export CSV",
        },
        outbox_multiple: "Multiple",
        leaderboards: {
            all_recognition: "All Recognition",
            recognition_metrics: "Recognition Metrics",
            recognition_metrics_sub: "Peer-to-peer recognition activity",
            most_recognition_given: "Most Recognition Given",
            most_recognition_given_sub: "Top givers of peer recognition",
            most_recognition_received: "Most Recognition Received",
            most_recognition_received_sub: "Top receivers of peer recognition",
            give_receive_ratio: "Highest Give-to-Receive Ratio",
            give_receive_ratio_sub: "Most peer recognition given per received",
            alignment_metrics: "Alignment Metrics",
            alignment_metrics_sub: "Values alignment performance",
            alignment_given: "Strongest Alignment Given",
            alignment_given_sub: "Most effective at reinforcing your values",
            alignment_received: "Strongest Alignment Received",
            alignment_received_sub: "Most aligned actions with your values",
            alignment_overall: "Strongest Alignment Overall",
            alignment_overall_sub: "Top culture & values ambassadors",
            see_full_list: "See full list",
        },
    },
    questions: {
        add_a_question: "Add a Question",
        preview_of_daily: "Preview of Daily Insights for Managers",
        summary_of_insights: "Summary of insights from your direct reports",
        of_ten_direct: "of 10 direct reports",
        responded: "responded",
        yes: "yes",
        average_rating_out: "average rating out of 10",
        english: "English",
        thai: "Thai",
        add_option: "Add Option",
        open_ended: "Open-ended",
        yes_or_no: "Yes/No",
        multiple_choice: "Multiple Choice",
        question: "Question",
        option: "Option",
        positive: "Positive",
        neutral: "Neutral",
        negative: "Negative",
        min_label: "Min.label",
        max_label: "Max.label",
        reward: "Reward",
        power_skill: "Power Skill",
        frequency: "Frequency",
        day_of_week: "Day of Week",
        schedule: "Schedule",
        please_select_frequency: "Please select frequency",
        and_when: "and when?",
        more: "more",
        assign_a_sentiment: "Assign a Sentiment",
        coins: "Coins",
        select_power_skill: "Select power skill (optional)",
        how_often_do: "How often do you want to ask this question?",
        what_day_of: "What day of week do you want to ask this question?",
        CALENDAR_VIEW: "Calendar View",
        Audience: "Audience",
        Active: "Active",
        Inactive: "Inactive",
        Show_All: "Show All",
        View: "View",
        Preview_of_Daily_Insights: "Preview of Daily Insights for Managers",
        Summary_of_insights_from: "Summary of insights from your direct reports",
        of_ten_direct_reports: "of 10 direct reports",
        responded_Yes: "responded “Yes”",
        average_rating_out_of: "average rating out of 10",
        of_fifty_overal: "of 50 overall",
        English: "English",
        Thai: "Thai",
        Positive: "Positive",
        Neutral: "Neutral",
        Negative: "Negative",
        Add_Option: "Add Option",
        Min_label: "Min.label",
        Max_label: "Max.label",
        Reward: "Reward",
        Power_Skill: "Power Skill",
        Select_power_skill: "Select power skill (optional)",
        Day_of_Week: "Day of Week",
        Please_select_frequency: "Please select frequency",
        Schedule: "Schedule",
        Type: "Type",
        Select_Dimension: "Select Dimension",
        Question_Format: "Question Format",
        Open_ended: "Open-ended",
        Yes_or_No: "Yes/No",
        Multiple_Choice: "Multiple Choice",
        Scale: "Scale",
        Question: "Question",
        Option: "Option",
        Frequency: "Frequency",
        Very_important: "Very important",
        Coins: "Coins",
        Status: "Status",
        Action: "Action",
        How_often__you: "How often do you want to ask this question?",
        What_day_of_week: "What day of week do you want to ask this question?",
        Not_at_all: "Not at all",
        QUESTION_DETAILS: "QUESTION DETAILS",
        Search: "Search",
        Assign_a_Sentiment: "Assign a Sentiment",
        Category: "Category",
        Row_Header: "Row Header",
        Row_Header_Placeholder: "A title that represents the insight from this question",
        preview_for_managers: "Preview for managers",
        email_subject_today: "Your team insights for today",
        today: "Today",
        three_insights: "3 insights",
        email_intro_shared: "Here's what your team shared today.",
        caption_of_four_direct: "of 4 direct reports",
        caption_of_fourteen_overall: "of 14 overall",
        responded_word: "responded",
        view_details: "view details",
        sample_response_placeholder: "A sample response from a team member will appear here once responses come in.",
        youve_replied: "You've replied",
        view_full_daily_report: "View full daily report",
        generate_placeholder: "I want to understand how well people understand our #excellence value",
        generate_question: "Generate Question",
        send_to: "Send to",
        follow_up: "Follow up",
        program_only: "Program only",
        response_settings: "Response Settings",
        rolling_response: "Rolling Response",
        rolling_response_tooltip: "Persist until the next occurrence of this question, delivering it until a response is provided",
        submit_responses_to_managers: "Submit Responses to Managers",
        private_feedback_mode: "Private Feedback Mode",
        private_feedback_hint: "Responses are hidden from managers and can only be viewed as anonymous feedback",
        report_card_analytics: "Report Card Analytics",
        include_in_report_card: "Include in Insights → Report Card",
        include_in_culture_index: "Include in Culture Index",
        culture_index_tooltip: "Include this question in the Culture Index calculation shown in Insights Dashboard",
        refreshing: "Refreshing...",
        refresh_calendar_title: "Refresh calendar and select today",
        legend_heavy_load: "Heavy load (>5 questions)",
        legend_light_load: "Light load (<4 questions)",
        legend_open_ended_questions: "Open-ended questions",
        dimension: "Dimension",
        delivery: "Delivery",
        essential_question_tooltip: "This is an essential question for our analytics and reports. It can be disabled in the Question List view but will require a confirmation.",
        toggle_off_tooltip: "Toggle off to remove this question from the daily question set (will affect recurring)",
        bi_weekly: "Bi-weekly",
        question_recipients: "Question Recipients",
        team_label: "Team",
        includes_child_teams: "Includes responses from child teams",
        all_teams: "All Teams",
        filter_by_team: "Filter by Team",
        search_teams_placeholder: "Search teams...",
        no_teams_found: "No teams found",
        combined_responses_prefix: "Showing combined responses from",
        combined_responses_suffix: "and its sub-teams",
        no_responses_available: "No responses available",
        no_responses_for_team: "No responses available for selected team",
        summary: "Summary",
        ai_generated_note: "AI-generated from feedback shared within 3 months of the selected date",
        responses_label: "responses",
        add_follow_up_question: "Add Follow-up Question",
        select_placeholder: "Select",
        SUBMIT: "SUBMIT",
        toast_include_row_header: "Please include a Row Header for your question",
        toast_input_option_prefix: "Please input Option",
        toast_include_version_prefix: "Please include a",
        toast_include_version_suffix: "version for your question",
        toast_select_dimension: "Please select Dimension",
        toast_select_question_format: "Please select Question Format",
        toast_input_coins: "Please input Coins",
        toast_select_frequency: "Please select Frequency",
        toast_select_day_of_week: "Please select Day of Week",
        toast_select_schedule: "Please select Schedule",
        toast_custom_question_created: "Your custom question has been created",
        question_saved: "Question saved",
        saved_follow_up_question: "Follow-up question saved",
        saved_question_calendar_hint: "The calendar has been updated with this question. You can review where it will appear, add another question, or close this window.",
        saved_follow_up_question_hint: "This was saved as a follow-up question, so it will appear when it is linked from a parent answer option instead of on the calendar.",
        saved_program_only_question: "Program-only question saved",
        saved_program_only_question_hint: "This was saved as a program-only question, so it will only fire when a program references it — not on the calendar.",
        view_in_calendar: "View in Calendar",
        add_another_question: "Add another question",
        done: "Done",
        saving_question: "Saving...",
        toast_custom_question_create_failed: "We couldn't save this question. Please try again.",
        toast_open_calendar_failed: "We couldn't open the calendar for this question. Please try again.",
        every: "Every",
        of_each_month: "of each month",
        first: "First",
        second: "Second",
        third: "Third",
        fourth: "Fourth",
        fifth: "Fifth",
        toast_yes_no_assignment_required: "Yes or No questions must have either a Positive & Negative assignment to either \"Yes\" or \"No\" options OR a Neutral assignment for both options.",
        toast_multi_choice_assignment_required: "Multiple choice questions must have at least one Positive & one Negative assignment OR a Neutral assignment for all options.",
        toast_input_min_max_label: "Please input min/max Label",
    },
    register: {
        get_started_with: "Get Started with Happily",
        set_up_one: "Set up 1 team",
        FREE: "FREE",
        BOOK_A_TIME: "BOOK A TIME",
        set_up_a: "Set up a free 21-day free trial for one team with",
        up_to_twenty: "up to 20 users",
        set_up_many: "Set up many teams",
        schedule_a_one: "Schedule a 1:1 session with our",
        team_who_will: "team who will ensure that you get",
        the_most_out: "the most out of Happily",
        Setting_up_your: "Setting up your account",
        help_us_get: "Help us get to know you and your company a bit better",
        your_name: "Your Name",
        please_input_your_name: "Please input your name",
        your_work_email: "Your work email",
        please_input_your_work: "Please input your work email",
        please_input_correct_email: "Please input correct email",
        your_phone_number: "Your phone number",
        please_input_your_phone: "Please input your phone number",
        please_input_only_number: "Please input only number",
        company_name: "Company Name",
        please_input_company: "Please input company name",
        Location: "Location",
        please_input_Location: "Please input location",
        Time_Zone: "Time Zone",
        please_input_Time_Zonen: "Please input time zone",
        language_preference: "Language Preference",
        how_many_people: "How many people",
        please_input_number_of: "Please input number of employees",
        please_input_language: "Please input language preference",
        what_would_you_like: "What would you like to achieve with Happily",
        please_input_your_achieve: "Please input your achieve",
        i_agree_to: "I agree to the",
        terms_and_conditions: "Terms & Conditions",
        verify_my_email: "Verify my email",
        confirm_your_email: "Confirm your email",
        we_sent_you: "We sent you an email verification code to ",
        the_email_may: "The email may take 15-20 seconds to get to you and will expire within the next 15 minutes",
        resend_code: "Resend Code",
        go_back: "Go back",
        book_a_meeting: "Book a Meeting",
        i_want_to: "I want to create a happier workplace.",
        Schedule_a_time_with: "Schedule a time with us",
        Setting_up_multiple_teams: "Setting up multiple teams would be easier through an import process that our team can guide you through. Book a meeting with us and we’ll get back to you (typically within the hour, up to 24 hours) to get you up and running in no time!",
    },
    reports: {
        DAILY_REPORT_PREVIEW: "DAILY REPORT PREVIEW",
        Select_a_Manager: "Select a Manager",
        Select_date: "Select date",
        Delivery_Status: "Delivery Status",
        Undelivered: "Undelivered",
        Delivered: "Delivered",
        Issue: "Issue",
        Read_Status: "Read Status",
        Preview_a_report_by: "Preview a report by selecting a manager and date",
        from_the_above_menu: "from the above menu",
        Loading: "Loading",
        Unable_to_preview_this: "Unable to preview this report due to unavailability of sufficient data",
        MONTHLY_REPORT_PREVIEW: "MONTHLY REPORT PREVIEW",
        Select_a_Person: "Select a Person",
        Select_month: "Select month",
        WEEKLY_REPORT_PREVIEW: "WEEKLY REPORT PREVIEW",
        quarterly: {
            main: {
                report_generator: "Report Generator",
                scope_label: "Scope",
                scope_placeholder: "Select Scope",
                company_wide: "Company-wide",
                quarter_label: "Quarter",
                quarter_placeholder: "Select Quarter",
                generate_report: "Generate Report",
                generating: "Generating...",
                loading_title: "Generating Your Report",
                empty_title: "Create a Slide Presentation",
                empty_text: "Select the scope and quarter above, then click Generate Report to create an executive slide deck.",
                generated_reports: "Generated Reports",
                search_placeholder: "Search reports...",
                loading_reports: "Loading reports...",
                col_report_name: "Report Name",
                col_quarter: "Quarter",
                col_created: "Created",
                col_updated: "Last Updated",
                col_actions: "Actions",
                view: "View",
                regenerate: "Regenerate",
                delete: "Delete",
                no_search_results: "No reports match your search.",
                no_reports_yet: "No generated reports yet. Create one above!",
                back_to_config: "Back to Configuration",
                pdf_title: "Preparing Your PDF",
                pdf_tip: "This may take a moment for large reports",
            },
            controls: {
                previous_slide: "Previous slide",
                next_slide: "Next slide",
                go_to_slide: "Go to slide",
                generating_pdf: "Generating PDF...",
                download_pdf: "Download as PDF",
                enter_fullscreen: "Enter fullscreen",
                exit_fullscreen: "Exit fullscreen",
            },
            viewer: {
                navigate: "Navigate",
                fullscreen: "Fullscreen",
                exit: "Exit",
            },
            title_cover: {
                badge: "EMPLOYEE ENGAGEMENT",
                title: "Quarterly Report",
            },
            closing: {
                contact_label: "Questions or feedback?",
                contact_text: "Contact your HR team",
                next_steps: "NEXT STEPS",
                generated: "Generated",
            },
            key_metric: {
                vs_last_quarter: "vs last quarter",
            },
            highlights: {
                strengths_title: "Strengths",
                strengths_subtitle: "Areas performing well",
                challenges_title: "Challenges",
                challenges_subtitle: "Areas needing attention",
                priorities_title: "Priorities",
                priorities_subtitle: "Recommended focus areas",
                empty_strengths: "No strengths identified",
                empty_challenges: "No challenges identified",
                empty_priorities: "No priorities identified",
            },
            chart_callouts: {
                key_insights: "KEY INSIGHTS",
                improvements: "Improvements",
                areas_of_concern: "Areas of Concern",
            },
            focus_alignment: {
                default_title: "Focus by Goal",
                default_subtitle: "How teams are aligning focus with organizational goals",
                items: "items",
                done: "done",
                open: "open",
                people: "people",
                unmatched_items: "Unmatched Items",
                not_linked: "Not linked to any goal",
                consider_linking: "Consider linking these to goals",
                unknown_items: "Alignment Unknown",
                no_goals_set: "No goals set for this scope",
                set_goals_to_assess: "Set goals to assess alignment",
                empty_text: "No goals with active focus this quarter",
            },
            goal_distribution: {
                items: "items",
                done_suffix: "% done",
                legend_completed: "Completed",
                legend_in_progress: "In Progress",
                empty_text: "No goals with active focus this quarter",
            },
            leaderboard: {
                empty_text: "No data available for this period",
            },
            question_scores: {
                legend_excellent: "70%+ Excellent",
                legend_moderate: "50-69% Moderate",
                legend_attention: "<50% Needs Attention",
            },
            recommendations: {
                ai_badge: "AI-POWERED INSIGHTS",
                default_title: "Key Recommendations",
                default_subtitle: "Strategic actions to drive engagement and performance",
                high_priority: "HIGH PRIORITY",
                medium: "MEDIUM",
                low: "LOW",
                high_impact: "High Impact",
                generated_by: "Generated by Happily.ai",
            },
            who5: {
                label_poor: "Poor",
                label_good: "Good",
                legend_0: "0 - At no time",
                legend_1: "1 - Some of the time",
                legend_2: "2 - Less than half",
                legend_3: "3 - More than half",
                legend_4: "4 - Most of the time",
                legend_5: "5 - All of the time",
            },
        },
    },
    rewards: {
        redeemed: "Redeemed",
        add_a_reward: "Add a Reward",
        active: "Active",
        inactive: "Inactive",
        show_all: "Show All",
        status: "Status",
        coins: "Coins",
        gems: "Gems",
        edit: "Edit",
        Reward: "Reward",
        Activity: "Activity",
        preview_on_mobile: "Preview on Mobile Layout",
        REDEEM: "REDEEM",
        REQUEST: "REQUEST",
        english: "English",
        thai: "Thai",
        name: "Name",
        name_of_reward: "Name of Reward",
        mame_of_reward_Thai: "Name of Reward (Thai)",
        description: "Description",
        description_Thai: "Description (Thai)",
        cost: "Cost",
        duration: "Duration",
        start_date: "Start Date",
        end_date: "End Date",
        gift_cards: "Gift Cards",
        perks: "Perks",
        team_building: "Team Building",
        doing_good: "Doing Good",
        settings: "Settings",
        country: "Country",
        all_countries: "All Countries",
        limited_qty: "Limited Qty",
        available: "Available",
        no_limit: "No limit",
        monthly_limit: "Monthly Limit",
        monthly_available: "{available} of {limit} available this month",
        monthly_resets_on_first: "Resets on the 1st of each month",
        limit_quantity: "Redemption limit",
        limit_unlimited: "Unlimited",
        limit_total: "Total cap",
        limit_monthly: "Per month",
        limit_unit_total: "total",
        limit_unit_per_month: "/ month",
        limit_total_helper: "Lifetime cap · counter never resets",
        limit_monthly_helper: "{available} of {limit} left this month · resets on the 1st",
        Require_Approval: "Require Approval",
        On: "On",
        Off: "Off",
        image: "Image",
        upload: "Upload",
        file_size_should: "File size should be 600 x 320 px. Reward thumbnail auto-generated to center square.",
        reward: "Reward",
        processing: "Processing",
        sent: "Sent",
        cancel: "Cancel",
        confirm_cancellation: "Confirm Cancellation",
        are_you_sure: "Are you sure you want to cancel the",
        redeemed_by: "redeemed by (Gifted to)",
        Recipient: "Recipient",
        Value: "Value",
        Type: "Type",
        Date_and_Time: "Date and Time",
        Delivered: "Delivered",
        no: "No",
        yes_and_refund: "Yes & Refund",
        yes_and_do: "Yes & Do Not Refund",
        refund: "Cancel & Refund",
        all_countries_label: "All Countries",
        member_countries_only: "Member Countries Only",
        enabled: "Enabled",
        disabled: "Disabled",
        show_all_status: "Show All Status",
        bulk_update_rates: "Bulk Update Rates",
        bulk_update_coin_rates: "Bulk Update Coin Rates",
        gem_exchange: "Gem Exchange",
        gem_exchange_editor: {
            title: "Gem Exchange",
            subtitle: "Let employees turn gems into coins.",
            enabled: "Enabled",
            disabled: "Disabled",
            shared_metadata: "Shared metadata",
            display_name: "Display name",
            display_name_hint: "Auto-generated — edit to customize.",
            image: "Image",
            image_default_hint: "Using default — upload to customize.",
            upload_image: "Upload image",
            replace_image: "Replace image",
            use_default: "Use default",
            image_hint: "JPG or PNG, max 2MB.",
            duration: "Duration",
            templates: "Templates",
            templates_hint_prefix: "Use",
            templates_hint_and: "and",
            templates_hint_suffix: "to insert tier values.",
            exchange_tiers: "Exchange tiers",
            exchange_tiers_hint: "Each tier becomes one reward in the Perks tab.",
            col_gems: "Gems",
            col_coins: "Coins",
            col_rate: "Rate",
            col_monthly_cap: "Monthly Cap",
            col_redemption_limit: "Limit",
            mode_total_short: "Total",
            mode_monthly_short: "/mo",
            no_limit: "No limit",
            per_gem: "per gem",
            best_value: "Best value",
            add_another_tier: "Add another tier",
            employee_preview: "Employee preview",
            employee_preview_hint: "How tier 1 appears on redemption.",
            save_changes: "Save changes",
        },
        tiers_active: "tiers active",
        tier_active: "tier active",
        no_tiers_yet: "No tiers yet",
        off: "Off",
        gem_exchange_on_add_tiers: "Gem Exchange is on. Add tiers to let employees redeem.",
        gem_exchange_intro: "Let employees convert gems into coins with configurable tiers.",
        edit_tiers: "Edit tiers",
        configure_arrow: "Configure →",
        set_up_arrow: "Set up →",
        new_badge: "NEW",
        expired_badge: "EXPIRED",
        managed: "Managed",
        managed_by_gem_exchange: "Managed by Gem Exchange",
        edit_a_reward: "Edit a Reward",
        linked_gem_variant: {
            create_title: "Create gem version",
            edit_title: "Edit gem version",
            subtitle: "Add a gem price while keeping the coin version available.",
            provider_linked: "Provider linked",
            coin_version_kept: "Coin version stays active",
            gem_version: "Gem version",
            gem_cost: "Gem cost",
            gem_cost_placeholder: "Enter the gems required",
            gem_cost_help: "Members spend gems. Billing still uses the original card value and provider.",
            create_action: "Create gem version",
            add_action: "Add gem version",
            edit_action: "Edit gem version",
            keep_coin_help: "The existing coin version remains available.",
            created: "Gem version created. The coin version is unchanged.",
            updated: "Gem version updated.",
            save_failed: "The gem version could not be saved.",
            errors: {
                missing_source_reward: "The company reward could not be found.",
                missing_master_reward: "The original provider reward could not be found.",
                invalid_gem_cost: "Enter a whole-number gem cost greater than zero.",
                inactive_master_reward: "The original provider reward is inactive.",
                missing_reward_name: "The original reward has no name.",
                missing_reward_type: "The original reward has no fulfillment type.",
                missing_face_value: "The original reward has no billable face value.",
                missing_reward_currency: "The original reward has no billing currency.",
                missing_provider_product_id: "The provider product ID is missing.",
                unable_to_create_variant_id: "A safe reward ID could not be created."
            }
        },
        type_placeholder: "Type",
        reward_activity: "Reward Activity",
        reward_activity_view: "Reward activity view",
        loading_activity: "Loading reward activity",
        updating_activity: "Updating activity…",
        loading_activity_hint: "Large date ranges can take a little longer. You can close this window while the data loads.",
        activity_load_error: "Reward activity could not be loaded",
        activity_load_error_hint: "Please check your connection and try again. Your reward data has not been changed.",
        activity_empty: "No reward activity for this period.",
        delivered: "Delivered",
        recipients: "Recipients",
        members: "Members",
        pending: "Pending",
        transactions: "Transactions",
        member_spend: "Member spend",
        member: "Member",
        redeemed_by_member: "Redeemed by",
        redemptions: "Redemptions",
        reward_spend: "Reward spend",
        share_of_currency_spend: "Share of currency spend",
        last_activity: "Last activity",
        member_spend_hint: "Delivered reward spend is attributed to the member who redeemed it, including gifts sent to someone else.",
        member_spend_empty: "No delivered reward spend for this period.",
        currency_totals_separate: "Currencies are kept separate so totals stay accurate.",
        currency_count: "{count} currencies",
        delivered_reward_spend: "Delivered reward spend",
        delivered_reward_spend_period: "Delivered reward spend · {period}",
        custom_date_range: "Custom Date Range",
        export: "Export",
        value: "Value",
        type: "Type",
        date_and_time: "Date & Time",
        date_range: "Date Range",
        to: "To",
        start_date_placeholder: "Start date",
        end_date_placeholder: "End date",
        confirm_and_filter: "Confirm & Filter",
        currency: "Currency",
        select_currency: "Select currency",
        current_rate: "Current Rate",
        new_rate: "New Rate",
        preview_changes: "Preview Changes",
        show_only_changes: "Show only changes",
        reward_name: "Reward Name",
        current: "Current",
        new_coins: "New Coins",
        change: "Change",
        no_rewards_for_currency: "No rewards found for the selected currency.",
        select_currency_hint: "Select a currency to view and update rewards.",
        apply: "Apply",
        changes_suffix: "Changes",
        change_singular: "Change",
        of: "of",
        toast_managed_by_gem_exchange: "Managed by Gem Exchange — use Edit tiers to enable/disable.",
        toast_confirm_activate: "Are you sure you would like to activate this reward?",
        toast_reward_activated: "Reward activated",
        toast_canceled: "Canceled",
        toast_confirm_disable: "Are you sure you would like to disable this reward?",
        toast_reward_disabled: "Reward disabled",
        toast_select_valid_date_range: "Please select a valid date range",
        toast_confirm_cancel_transaction: "Are you sure you would like to cancel this reward transaction?",
        toast_transaction_canceled: "The reward has been successfully canceled",
        toast_coins_gems_refunded_prefix: "The coins or gems will be refunded to",
        toast_confirm_status_change: "Are you sure to you want to change the status of item?",
        toast_status_updated: "Status updated",
        toast_select_image: "Please select an image",
        toast_confirm_delete: "Are you sure you want to delete this reward?",
        toast_reward_deleted: "Reward Deleted",
        toast_reward_added: "Reward successfully added",
        toast_reward_updated: "Reward updated",
        toast_avatar_format_error: "Avatar picture must be JPG format!",
        toast_avatar_size_error: "Avatar picture size can not exceed 2MB!",
    },
    sparks: {
        custom_sparks: "custom sparks",
        program_only: "Program only",
        Create_a_Set: "Create a Set",
        Set: "Set",
        HAPPILY_S_SPARKS: "HAPPILY’S SPARKS",
        Name_of_Spark_Set: "Name of Spark Set",
        Please_input_Set_Name: "Please input Set Name",
        Display_After: "Display After",
        Before_Set_one: "Before Set 1",
        Audience: "Audience",
        Set_name: "Set name",
        Select: "Select",
        SAVE_CHANGES: "SAVE CHANGES",
        CANCEL: "CANCEL",
        DELETE_SPARK_SET: "DELETE SPARK SET",
        CREATE_SET: "CREATE SET",
        Title: "Title",
        Edit: "Edit",
        Draft: "Draft",
        Create_a_New_Card: "Create a New Card",
        Spark_Title: "Spark Title",
        Please_input_Spark_Title: "Please input Spark Title",
        Spark_Icon: "Spark Icon",
        Spark_Content_English: "Spark Content - English",
        Spark_Content_Thai: "Spark Content - Thai",
        SAVE_SPARK: "SAVE SPARK",
        DELETE: "DELETE",
        nudges: "Nudges",
        nudges_col_dimension: "Dimension",
        nudges_col_nudge: "Nudge",
        nudges_col_recipient: "Recipient",
        nudges_col_date_time: "Date & Time",
        nudges_expand_all: "Expand all in set",
        nudges_hide_all: "Hide all in set",
        nudges_load_more: "Load more",
        new_spark_set: "New Spark Set",
        ai_placeholder: "What skills or knowledge do you want to develop micro learning on?",
        generate_spark_set: "Generate Spark Set",
        untitled: "UNTITLED",
        spark_content_prefix: "Spark Content -",
    },
    demomode: {
        demo_on: "Demo Mode On",
        demo_tooltip: "Usernames and team names will be censored. Go to Settings for more information.",
        detected_title: "We detected that you had left demo mode on since your last login.",
        detected_sub: "Don't worry, we'll keep it on between page refreshes.",
        warning: "WARNING: NAMES AND DETAILS SHOWN IN THE REPORT WILL NOT BE CENSORED",
    },
    sso: {
        your: "Your",
        this_account: "This account",
        has_been_set: "has been set up to use single sign-on",
        google_sign_In: "Google Sign-In",
        sign_In: "Sign-In",
        sign_Out: "Sign-Out",
        mobile_welcome_to: "Welcome to",
        mobile_account_set_to_login: "Your account is set to login via SSO",
    },
    performance: {
        focus_areas: {
            select_team: "Select Team",
            all_teams: "All Teams",
            search: "Search",
            without_focus: "Without Focus",
            with_partners: "With Partners",
            goal_alignment: "Goal Alignment",
            all_items: "All Items",
            with_goal: "With Goal",
            without_goal: "Without Goal",
            people: "People",
            total: "total",
            with_focus: "with focus",
            no_focus: "no focus",
            focus_coverage_trend: "Focus Coverage Trend",
            last: "Last",
            weeks: "weeks",
            days: "days",
            focus_items: "Focus Items",
            unique: "unique",
            open: "open",
            done: "done",
            focus_insights: "Focus Insights",
            focus_distribution: "Focus Distribution",
            in_progress: "In Progress",
            completed: "Completed",
            team_metrics: "Team Metrics",
            team: "Team",
            tooltip_total_people: "Total number of people in this team",
            tooltip_focusing: "Percentage of people with at least one focus item",
            focusing: "Focusing",
            tooltip_items_open_done: "Number of in-progress items / completed items",
            items_open_done: "Items (Open / Done)",
            tooltip_completion: "Percentage of focus items marked as done",
            completion: "Completion",
            tooltip_partnership: "Percentage of focus items that have at least one partner",
            partnership: "Partnership",
            no_results_found: "No Results Found",
            no_focus_data_available: "No Focus Data Available",
            adjust_filters_hint: "Try adjusting your filters or search terms",
            empty_state_hint: "Focus areas will appear here once people start setting them",
            no_focus_items: "No focus items",
            no_items_in_progress: "No items in progress",
            no_completed_items: "No completed items",
            focus_item_details: "Focus Item Details",
            focus_item_label: "FOCUS ITEM",
            description_label: "DESCRIPTION",
            status_label: "STATUS",
            focus_partners: "Focus Partners",
            no_partners_for_item: "No partners for this focus item",
            partners_view: "Partner's View:",
            your_view: "Your View:",
        },
        emergent_goals: {
            discover_goals: "Discover Goals",
            header_subtitle: "AI-powered suggestions from unmatched work",
            run_fresh_analysis: "Run fresh AI analysis",
            refresh: "Refresh",
            close: "Close",
            loading_hint: "This usually takes 30-60 seconds",
            try_again: "Try Again",
            all_caught_up: "All Caught Up",
            all_caught_up_desc: "No clear patterns found in your unmatched focus items. Your team's work might already be well-aligned with existing goals.",
            auto_matched_desc: "focus items automatically matched to existing goals",
            hide: "Hide",
            show: "Show",
            review_matches: "Review Matches",
            matches_need_confirmation: "These matches need your confirmation",
            focus_item: "Focus Item",
            suggested_goal: "Suggested Goal",
            accept: "Accept",
            skip: "Skip",
            matched: "Matched",
            skipped: "Skipped",
            suggested_new_goals: "Suggested New Goals",
            new_goals_desc: "New goals discovered from patterns in unmatched work",
            team: "Team",
            recommended: "Recommended",
            select_team: "Select team",
            link_to_parent: "Link to Parent Goal",
            optional: "Optional",
            select_parent_goal: "Select parent goal(s)",
            no_ancestor_goals: "No ancestor team goals available",
            create_goal: "Create Goal",
            created: "Created",
            done: "Done",
        },
        talent_matrix: {
            select_team: "Select Team",
            all_teams: "All Teams",
            x_axis: "X-Axis",
            y_axis: "Y-Axis",
            swap_axes: "Swap axes",
            color_by_talent_type: "Color by Talent Type",
            color_by_team: "Color by Team",
            no_coloring: "No Coloring",
            export_csv: "Export CSV",
            higher_is_better: "Higher is better",
            lower_is_better: "Lower is better",
            employee_details: "Employee Details",
            employees: "employees",
            employee: "Employee",
            network: "Network",
            talent_type: "Talent Type",
            quadrant: "Quadrant",
            engagement_wellbeing: "Engagement & Well-being",
            happiness_score: "Happiness Score",
            engagement_score: "Engagement Score",
            flight_risk: "Flight Risk",
            performance_growth: "Performance & Growth",
            impact_rating: "Impact Rating",
            performance_score: "Performance Score",
            focus_score: "Focus Score",
            goal_alignment: "Goal Alignment",
            recognition_trust: "Recognition & Trust",
            trust_score: "Trust Score",
            peer_trust_count: "Peer Trust Count",
            giving_recognition: "Giving Recognition",
            receiving_recognition: "Receiving Recognition",
            medals: "Medals",
            power_skills_eq: "Power Skills (EQ)",
        },
        goals: {
            search_members: "Search members",
            include_subteams: "Include Sub-teams",
            include_subteams_tooltip: "When enabled, focus alignment stats include all sub-teams",
            show_archived: "Show Archived",
            show_archived_tooltip: "Show archived goals that have been soft-deleted",
            krs_by_team: "KRs by Team",
            krs_by_individual: "KRs by Individual",
            goal_alignment_tooltip: "Percentage of focus items linked to team goals",
            expand_teams_to_load: "Expand teams to load",
            aligned: "aligned",
            unaligned: "unaligned",
            unknown: "Unknown",
            unknown_items: "focus items with unknown alignment",
            focus_items_alignment_unknown: "focus items have unknown goal alignment because no goals are set",
            focus_items_not_aligned: "focus items are not aligned to any goal",
            no_goals_to_map: "No goals to map against",
            members_with_krs: "Members with KRs",
            total_krs: "Total KRs",
            assigned: "assigned",
            avg_progress: "Avg Progress",
            kr_status: "KR Status",
            on_track: "on track",
            at_risk: "at risk",
            off_track: "off track",
            goal_focus_trends: "Goal Focus Trends",
            hide_items: "Hide items",
            view_items: "View items",
            has_value: "Has Value",
            no_value: "No Value",
            no_teams_found: "No Teams Found",
            no_teams_available: "No Teams Available",
            no_teams_adjust_filters: "Try adjusting your search terms or filters",
            no_teams_empty_hint: "Teams will appear here once they are created",
            col_team: "TEAM",
            col_goals: "GOALS",
            goal_name_placeholder: "Goal name",
            save_changes: "Save changes",
            archived: "Archived",
            edit_goal: "Edit goal",
            archive_goal: "Archive goal",
            restore_goal: "Restore goal",
            delete_permanently: "Delete permanently",
            no_focus_on_goal_tooltip: "No one is focusing on this goal",
            linked_to_parent_goals: "Linked to parent goals:",
            goal_description_placeholder: "Goal description",
            goal_edit_hint: "Edit the goal description above. Use the Save button in the header to confirm changes.",
            key_results: "Key Results",
            ai_suggest_krs_tooltip: "AI-suggest measurable key results",
            add_kr_manually_tooltip: "Add key result manually",
            no_kr_empty_hint: "Add measurable key results to track progress",
            new_key_result: "New Key Result",
            kr_title_placeholder: "Key result title",
            start: "Start",
            target: "Target",
            unit: "Unit",
            unit_placeholder: "e.g. %",
            owners: "Owners",
            assign_members_placeholder: "Assign team members",
            teams_group_label: "Teams",
            people_group_label: "People",
            tracking_mode: "Tracking Mode",
            tracking_collaborative: "Collaborative — shared progress",
            tracking_individual: "Individual — per person",
            tracking_collaborative_hint: "Everyone contributes to one number",
            tracking_individual_hint: "Each person tracks their own progress",
            tracking_individual_decreasing_warning: "Individual tracking sums each owner's value, which doesn't work when the target is lower than the start.",
            tracking_decreasing_reframe_hint: "Consider reframing as an increasing metric — e.g., \"Increase retention to 80%\" instead of \"Reduce churn to 20%\".",
            targets_per_owner: "Targets per owner",
            owner_targets_match: "Individual targets total {sum} / team target {team}",
            owner_targets_short: "Individual targets total {sum} — team target is {team} ({delta} short)",
            owner_targets_over: "Individual targets total {sum} — team target is {team} ({delta} over)",
            owner_target_reset_tooltip: "Reset to default share",
            owner_target_customized_hint: "Custom target",
            owner_target_customized_tag: "Custom",
            owner_targets_match_action: "Match team target to {sum}",
            cycle: "Cycle",
            cycle_placeholder: "Evergreen (no cycle)",
            add_key_result: "Add Key Result",
            parent_goal_links: "Parent Goal Links",
            edit_links: "Edit Links",
            add_links: "Add Links",
            no_parent_links_yet: "No parent goals linked yet",
            people_focusing_on_goal: "People focusing on this goal:",
            no_members_found: "No Members Found",
            no_members_available: "No Members Available",
            select_team_to_view: "Select a team to view member KRs",
            krs_label: "KRs",
            no_krs_assigned: "No KRs assigned",
            tab_freeform: "Freeform",
            tab_advanced: "Advanced",
            freeform_description: "Enter your goals as free text. AI will structure them into individual goals with descriptions.",
            advanced_description_existing: "Edit existing goals or add new ones.",
            advanced_description_new: "Add goals directly with titles and descriptions. No AI transformation required.",
            goal_label: "Goal",
            existing: "Existing",
            new: "New",
            goal_title_placeholder: "Goal title (e.g., Increase customer satisfaction)",
            goal_description_optional_placeholder: "Description (optional - provide more details about this goal)",
            link_to_parent_goals: "Link to Parent Goals",
            linked: "linked",
            select_parent_goals_placeholder: "Select parent goals to align with...",
            no_parent_team_goals: "No parent team goals available to link",
            add_another_goal: "Add another goal",
            link_subtitle: "Align this goal with higher-level objectives",
            current_goal: "Current Goal",
            no_parent_goals_available: "No Parent Goals Available",
            no_parent_goals_desc: "Parent teams need to have goals set up before you can create alignment links.",
            select_parent_goals: "Select Parent Goals",
            links: "Links",
            link_noun: "Link",
            remove_all_links: "Remove All Links",
            toast_updated: "Goal updated successfully",
            toast_update_failed: "Failed to update goal",
            toast_archived: "Goal archived successfully",
            toast_archive_failed: "Failed to archive goal",
            toast_restored: "Goal restored successfully",
            toast_restore_failed: "Failed to restore goal",
            toast_deleted: "Goal deleted permanently",
            toast_delete_failed: "Failed to delete goal",
            kr_cycle: "CYCLE",
            kr_cycle_placeholder: "Evergreen",
            kr_start: "START",
            kr_target: "TARGET",
            kr_unit: "UNIT",
            kr_collaborative: "Collaborative",
            kr_individual: "Individual",
            kr_status_on_track: "On Track",
            kr_status_at_risk: "At Risk",
            kr_status_off_track: "Off Track",
            kr_status_completed: "Completed",
            kr_search_team_or_member: "Search team or member",
            kr_teams_section: "Teams",
            kr_people_section: "People",
            kr_no_members_found: "No members found",
            kr_clear_all: "Clear all",
            kr_note_placeholder: "Note (optional)",
            kr_status_auto: "Auto (from progress)",
            kr_status_manual_dot_tooltip: "Status set manually by {name}",
            kr_status_manual_dot_tooltip_unknown: "Status set manually",
            kr_meta_updated_by: "Updated {time} by {name}",
            kr_meta_updated_auto: "Updated {time} automatically",
            kr_meta_updated: "Updated {time}",
            kr_history_title: "Update history",
            kr_history_empty: "No updates yet",
            kr_history_show_all: "Show all {count} updates",
            kr_history_automation_actor: "Automation",
            kr_history_team_total: "Team total {value}",
            kr_history_unknown_actor: "Unknown",
            kr_detail_eyebrow: "Key Result",
            kr_detail_of_target: "of target",
            kr_detail_delta_since: "{delta} since last update",
            kr_detail_chart_title: "Progress over time",
            kr_detail_chart_empty: "Not enough updates to chart yet — each progress update will plot here.",
            kr_detail_target_label: "Target",
            kr_detail_owners: "Owners",
            kr_detail_no_owners: "No owners assigned yet",
            kr_detail_automation: "Automation",
            kr_detail_last_synced: "Last synced {time}",
            kr_detail_last_checked: "Last checked {time}",
            kr_detail_awaiting_sync: "Awaiting first sync",
            kr_detail_automation_paused: "Automation paused",
            kr_detail_cadence_daily: "runs daily at {time}",
            kr_detail_cadence_weekly: "runs weekly on {day} at {time}",
            kr_detail_cadence_monthly: "runs monthly on day {dayOfMonth} at {time}",
            kr_detail_reconnect: "Reconnect",
            kr_detail_edit_automation: "Edit automation",
            kr_detail_pause_automation: "Pause",
            kr_detail_resume_automation: "Resume",
            kr_detail_delete_automation: "Delete",
            kr_detail_update_progress: "Update progress",
            kr_detail_edit_kr: "Edit key result",
            kr_detail_save_update: "Save update",
            suggest_kr_title: "Suggest Key Results",
            suggest_kr_subtitle: "AI-powered measurable outcomes for your goal",
            run_fresh_ai_analysis: "Run fresh AI analysis",
            refresh: "Refresh",
            kr_loading_hint: "This usually takes 15-30 seconds",
            try_again: "Try Again",
            no_suggestions_title: "No Suggestions Available",
            no_suggestions_desc: "Try adding more detail to the goal description or aligning more focus items to this goal.",
            goal_context: "Goal Context",
            kr_added: "Added",
            kr_skipped: "Skipped",
            kr_confidence: "confidence",
            kr_ai_reasoning: "AI Reasoning",
            kr_owner: "Owner",
            kr_assign_later: "Assign later",
            kr_skip: "Skip",
            kr_accept: "Accept",
            toast_confirm_delete_kr: "Delete this key result? This cannot be undone.",
            toast_delete_kr_title: "Delete Key Result",
            toast_confirm_delete_automation: "Delete this automation? The Key Result and its update history will be kept, but automatic updates will stop.",
            toast_delete_automation_title: "Delete Automation",
            toast_automation_paused: "Automation paused",
            toast_automation_resumed: "Automation resumed",
            toast_automation_deleted: "Automation deleted",
            toast_automation_update_failed: "Could not update the automation",
            toast_automation_delete_failed: "Could not delete the automation",
            toast_add_at_least_one_goal: "Please add at least one goal with a title",
            toast_goal_title_too_long: "Goal titles must be 30 characters or less",
            toast_goals_saved_successfully: "Goals saved successfully",
            toast_no_data_to_export: "No data to export",
            toast_goal_title_too_long_single: "Goal title must be 30 characters or less",
            toast_confirm_save_changes: "Are you sure you want to save changes to this goal?",
            toast_confirm_changes_title: "Confirm Changes",
            toast_failed_to_update_goal: "Failed to update goal",
            toast_confirm_archive: "Are you sure you want to archive this goal? It can be restored later from the \"Show Archived\" view.",
            toast_archive_title: "Archive Goal",
            toast_confirm_restore: "Are you sure you want to restore this goal? It will be visible in the active goals list.",
            toast_restore_title: "Restore Goal",
            toast_confirm_delete_goal: "Are you sure you want to permanently delete this goal? This action cannot be undone.",
            toast_delete_goal_title: "Delete Goal",
            toast_goal_linked_prefix: "Goal linked to",
            toast_goal_linked_suffix: "parent goal(s)",
            toast_parent_links_removed: "Parent goal links removed",
            toast_failed_update_goal_links: "Failed to update goal links",
        },
    },
    settings: {
        page_title: "Settings",
        page_description: "Manage company-wide features, communications, and experiences",
        save_changes: "Save Changes",
        undo: "Undo",
        changes_banner: "You've made changes to your settings",
        tab_general: "General Settings",
        tab_performance: "Performance Reviews",
        tab_values: "Skills & Values",
        tab_village: "Happily Village",
        tab_email_notifications: "Email Notifications",
        section_general: "COMPANY & COMMUNICATION",
        section_general_description: "Manage company details, delivery schedules, holidays, feed preferences, privacy, and support access.",
        company_name: "Company Name",
        pulse_report_schedule: "Pulse & Report Schedule",
        pulse_report_schedule_description: "Choose when employee pulse questions and manager insight reports are delivered.",
        daily_pulse: "Daily Pulse",
        daily_insights: "Daily Insights",
        weekly_insights: "Weekly Insights",
        monthly_insights: "Monthly Insights",
        company_holidays: "Company Holidays",
        company_holidays_description: "Pause Daily Pulse questions for everyone on company-wide holidays.",
        add_holidays: "Add Holidays",
        personal_holiday_presets: "Personal Holiday Presets",
        personal_holiday_presets_description: "Create reusable schedules that pause Daily Pulse questions for specific teams or members on their days off.",
        set_personal_holiday: "Set Personal Holiday",
        activity_feed_names: "Activity Feed Names",
        activity_feed_names_description: "Choose whether the Activity Feed shows a member's nickname or first name.",
        use_nicknames_in_activity_feed: "Use nicknames in Activity Feed",
        activity_feed_rewards: "Reward Activity",
        activity_feed_rewards_description: "Choose whether reward redemptions appear in the Activity Feed.",
        show_reward_redemptions_in_activity_feed: "Show reward redemptions in Activity Feed",
        allow_cross_location_gift_rewards: "Allow cross-location gift rewards",
        allow_cross_location_gift_rewards_description: "Let employees send gift rewards to colleagues in other countries or locations. Local rewards may still show a warning if the recipient may not be able to redeem them.",
        happily_assistance: "Happily Assistance",
        happily_assistance_description: "Allow the Happily team to access your company console for account support and recommendations.",
        happily_assist_access: "Happily Assist Access",
        demo_mode: "Demo Mode",
        demo_mode_description: "Blur member names, emails, teams, and profile photos when presenting or sharing your screen. Demo Mode reduces exposure but may not hide every piece of personal information.",
        enable_demo_mode: "Enable Demo Mode",
        section_performance: "REVIEWS & FEEDBACK",
        section_performance_description: "Control manager review tools, review status timing, and reflection prompts.",
        enable_performance_boosts: "Enable Performance Boosts",
        enable_performance_boosts_description: "Let managers provide structured feedback and recognition through gem awards. These awards contribute to employee Impact Ratings.",
        performance_boosts: "Performance Boosts",
        performance_boost_notice: "Review Status Timing",
        performance_boost_notice_description: "Choose when an incomplete review becomes pending and when it becomes overdue.",
        pending_after: "Pending after",
        overdue_after: "Overdue after",
        ai_reviewed_feedback: "AI-Reviewed Feedback",
        reset_monthly: "Reset Monthly",
        section_values: "RECOGNITION & PEER FEEDBACK",
        section_values_description: "Define the values and skills people use when recognizing colleagues and giving feedback.",
        recognition_values: "Recognition Values",
        recognition_values_description: "Define the company values people can attach to peer and manager recognition. Values appear as hashtags in recognition flows.",
        new_value: "New Value",
        peer_feedback: "Peer Feedback",
        peer_feedback_description: "At the start of each month, members can choose up to two colleagues to request feedback from. Reviewers use the skills below to describe where each colleague excels.",
        peer_feedback_interactions: "Peer Feedback Interactions",
        new_skill: "New Skill",
        section_village: "ACCESS & PARTICIPATION",
        section_village_description: "Manage Village access, House scoring, discussion permissions, and AI-generated topics.",
        village_access: "Village Access",
        village_access_description: "Give all members access to Happily Village experiences, including the Running Track, University, Houses, Town Hall, and Battle Stadium.",
        happily_village_access: "Happily Village Access",
        fair_play_boost: "Battle Stadium Fair Play Boost",
        fair_play_boost_description: "Balance House Scores when house sizes differ significantly. Personal XP and mission leaderboards are not adjusted.",
        fair_play_boost_enabled_note: "Enabled. House sizes will be checked when the next Monday mission opens. The active mission will not change.",
        fair_play_boost_disabled_note: "Disabled. House Scores will use the standard scoring method. Changes take effect with the next Monday mission.",
        topic_creation_permissions: "Topic Creation Permissions",
        topic_creation_permissions_description: "Control who can initiate discussions in the Town Hall. When restricted, only company admins can create new topics, while all employees can still participate in existing discussions.",
        allow_employee_topic_creation: "Allow Employee Topic Creation",
        town_hall_agent: "Town Hall Agent",
        town_hall_agent_description: "Use AI to create Town Hall topics and polls based on the conversation themes you choose below.",
        performance_conversations: "Performance Conversations",
        performance_conversations_description: "After a key result update, invite a short reflection that starts a conversation with the manager. Words go to the manager only. The key result timeline shows a neutral summary.",
        add_theme: "Add Theme",
        section_email_notifications: "MANAGER & HR EMAILS",
        section_email_notifications_description: "Choose which activity alerts, recurring reports, and feedback details are sent by email.",
        cancel: "Cancel",
        confirm: "Confirm",
        toast_valid_data_required: "Valid Data required.",
        toast_saving_changes: "Saving changes...",
        toast_generated_attributes_prefix: "Generated",
        toast_generated_attributes_middle: "attributes for",
        toast_generate_attributes_failed: "Failed to generate attributes. Please try again.",
        toast_this_value: "this value",
        toast_recognition_delete_prefix: "Any recognition sent with",
        toast_recognition_delete_suffix: "will lose its association with this value. This can't be undone.",
        toast_delete_label: "Delete",
    },
    skills: {
        learning_journeys: {
            select_placeholder: "Select",
            overview: "Overview",
            active_learning_journeys: "Active Learning Journeys",
            completed_journeys: "Completed Journeys",
            members_upskilled: "Members Upskilled",
            learning_time: "Learning Time",
            activation_channel: "Activation Channel",
            activation_channel_description: "Learning journeys initiated by managers (performance focus) or self-initiated (personal growth)",
            manager: "Manager",
            self: "Self",
            top_learners: "Top Learners",
            top_learners_subtitle: "Team members with the most learning journeys",
            view_all: "View All",
            learning_journey_progress: "Learning Journey Progress",
            view_skill_category_analytics: "View Skill Category Analytics",
            status: "Status",
            skill_set: "Skill Set",
            progress: "Progress",
            initiated_by: "Initiated by",
            assigned_to: "Assigned To",
            date_time: "Date & time",
            loading_more_items: "Loading more items...",
            end_of_list: "End of list",
            empty_state: "No learning journeys found matching your filters.",
            top_learners_explanation: "Team members who have participated in the most learning journeys during the selected time period",
            search_member: "Search member",
            no_learners_found: "No learners found matching your search.",
            skill_category_analytics: "Skill Category Analytics",
            skill_category_analytics_subtitle: "Distribution of learning journeys by skill category",
            time_period: "Time Period:",
            search_category: "Search category",
            categories: "Categories",
            total_journeys: "Total Journeys",
            active: "Active",
            completed: "Completed",
            category: "Category",
            distribution: "Distribution",
            total: "Total",
            no_categories_found: "No categories found matching your search.",
        },
        power_skills: {
            select_placeholder: "Select",
            all_teams: "All Teams",
            team: "Team",
            progress_and_ratings: "Power Skills Progress & Ratings",
            progress_and_ratings_subtitle: "The overall effort score for practicing each skill with a rating trend and leaderboard from the past 6-months",
            loading: "Loading Power Skills data...",
            error_title: "Unable to load Power Skills data",
            retry: "Retry",
            empty_title: "No Power Skills data available",
            empty_description: "There's no data to display for the selected criteria.",
            company_avg: "Company Avg.",
            percentile_75th: "75th",
            median: "Median",
            percentile_25th: "25th",
            leaderboard: "LEADERBOARD",
            sort_by: "Sort by",
            sort_all: "All",
            ascending_rating: "Ascending Rating",
            ascending_score: "Ascending Score",
            descending_rating: "Descending Rating",
            descending_score: "Descending Score",
        },
        development: {
            select_placeholder: "Select a team",
            all_teams: "All Teams",
            search: "Search members",
            members_label: "members",
            vs_prior: "vs prior",
            member: "Member",
            rating_trend: "Rating trend",
            top_strength: "Top strength",
            development_area: "Development area",
            journeys: "Journeys",
            summary: "Summary",
            fresh: "Fresh",
            stale: "Stale",
            needs_data: "Needs data",
            none: "Not generated",
            completed_short: "done",
            active_short: "active",
            evidence: "Evidence",
            peer_count: "{n} peer",
            peers_count: "{n} peers",
            manager_review_count: "{n} manager review",
            manager_reviews_count: "{n} manager reviews",
            no_manager_reviews_short: "No manager reviews",
            no_feedback_yet: "No feedback yet",
            what_changed: "What changed",
            vs_previous_months: "vs previous {n} months",
            peer_rating: "Peer rating",
            manager_goals: "Manager · Goals",
            manager_culture: "Manager · Culture",
            mv_improved: "Improved",
            mv_new_strength: "New strength",
            mv_still_developing: "Still developing",
            mv_watch: "Watch",
            mv_growth_to_strength: "growth area ×{was} then, now a strength ×{now}",
            mv_new_strength_detail: "strength ×{now} this period, not cited before",
            mv_still_detail: "growth area both periods (×{was} → ×{now})",
            mv_watch_detail: "was a strength, now a growth area ×{now}",
            consistent_picture: "Consistent picture. No skills changed sides.",
            recognized_for: "Recognized for:",
            new_short: "new",
            volume_caption: "Based on {nowFb} feedback from {nowPeers} peers and {nowReviews} manager reviews (vs {prevFb} from {prevPeers} peers, {prevReviews} reviews prior)",
            open_hint: "Click a member to open their development picture",
            back: "Back to roster",
            export: "Export",
            regenerate: "Regenerate",
            generated_on: "Generated",
            development_summary: "Development summary",
            provenance: "Generated from {feedback} feedback events, {journeys} journeys, {reviews} reviews",
            strengths_themes: "Strengths",
            development_areas: "Development areas",
            trajectory_statement: "Trajectory",
            suggested_focus: "Suggested focus",
            summary_unavailable: "Summary unavailable right now.",
            retry: "Retry",
            needs_data_hint: "Not enough feedback in this period to generate a summary. Evidence below shows what exists so far.",
            trajectory: "Trajectory",
            trajectory_hint: "Average peer-feedback rating received per month (1-4)",
            skills_title: "Strengths & development areas",
            skills_hint: "Peer feedback mentions in this period, with change vs the prior period",
            strengths: "Strengths",
            mentions: "mentions",
            evidence_journeys: "Learning journeys",
            evidence_recognition: "Recognition",
            evidence_behaviors: "Feedback behaviors",
            evidence_performance: "Performance",
            journeys_completed: "Completed",
            journeys_active: "In progress",
            learning_time: "Learning time",
            no_journeys: "No journeys in this period",
            received: "Received",
            given: "Given",
            no_recognition: "No recognition in this period",
            requested: "Requested",
            response_rate: "Response rate",
            no_feedback: "No feedback activity in this period",
            no_reviews: "No reviews",
            goal_rating: "Goals",
            culture_rating: "Culture",
            no_ratings: "No ratings yet",
            no_members: "No members match the current filters",
            member_not_found: "This member isn't in the current roster.",
            rating_truly: "Truly Outstanding",
            rating_exceeding: "Exceeding Expectations",
            rating_meeting: "Meeting Expectations",
            rating_needs: "Needs Improvement",
            holding: "holding",
            generate_report: "Generate report",
            generate_hint: "The AI development summary is generated on demand and cached for later visits.",
            generating: "Generating…",
            not_generated: "Not generated",
            deterministic_brief: "Development brief",
            strongest_signal: "Strongest signal",
            most_cited_growth: "Most-cited growth area",
            rating_label: "Rating",
            typically: "typically {label}",
            what_peers_said: "What peers said",
            mentions_count: "{n} mentions",
            mention_count: "{n} mention",
            new_label: "new",
            paraphrased_from: "Paraphrased from {n} comments",
            paraphrased_from_one: "Paraphrased from 1 comment",
            also_growth_note: "Also named a growth area by {n} peers",
            also_praised_note: "Also praised by {n} peers",
            privacy_quotes: "Quotes are AI-paraphrased and anonymous; original comments are never shown.",
            privacy_pre_ai: "Until the AI report is generated, this section lists cited behaviors and counts only.",
            self_reflection: "Self reflection · in their own words",
            own_answer_verbatim: "Their own answer, shown verbatim",
            reflection_source: "From {name}'s answers to Self Awareness reflection questions in this period ({n} total).",
            development_story: "Development story",
            feedback_loops: "Feedback loops — who, and when",
            peer_feedback_received: "Peer feedback received",
            manager_review_boost: "Manager review boost",
            manager_role: "manager",
            others_row: "{n} others",
            other_row: "1 other",
            growth_moments: "Growth moments",
            feedback_from: "Feedback from {names}",
            feedback_from_peers: "Feedback from {n} peers",
            baseline_title: "Baseline",
            now_title: "Now",
            manager_review_title: "Manager review boost",
            goals_label: "Goals",
            culture_label: "Culture",
            journeys_also: "Also this period: {done} journeys completed, {progress} in progress — {cats}.",
            journeys_also_none_progress: "Also this period: {done} journeys completed — {cats}.",
            manager_review_boosts: "Manager review boosts",
            no_manager_reviews: "No manager reviews in this period.",
            from_name: "from {name}",
            skill_balance: "Skill balance",
            activity_footnote: "Feedback activity this period: {received} received from {givers} givers · gave {given} — full activity lives in Proficiencies. Values recognition received: {tags} ({events} events).",
            strengths_cited: "Strengths cited: {names}.",
            growth_cited: "Growth: {names}.",
        },
        proficiencies: {
            select_placeholder: "Select",
            all_teams: "All Teams",
            all_time: "All-time",
            past_year: "Past year",
            past_6_months: "Past 6-months",
            past_3_months: "Past 3-months",
            current_month: "Current month",
            last_month: "Last month",
            overview: "Overview",
            rating_overview: "Rating Overview",
            rating_overview_description: "A distribution of ratings towards company goals from peer feedback interactions.",
            truly_outstanding: "Truly Outstanding",
            exceeding_expectations: "Exceeding Expectations",
            meeting_expectations: "Meeting Expectations",
            needs_improvement: "Needs Improvement",
            highest_rated: "Highest Rated",
            highest_rated_description: "Individuals with the highest peer feedback ratings, on a 1 to 4 scale",
            lowest_rated: "Lowest Rated",
            lowest_rated_description: "Individuals with the lowest peer feedback ratings, on a 1 to 4 scale",
            see_all: "see all",
            skills_proficiency: "Skills Proficiency",
            skills_excel_at: "Skills That People Excel At",
            skills_improve_at: "Skills That People Could Improve At",
            skill_selected_description: "The number of times a skill was selected (compared with previous time period)",
            excels_at: "Excels at",
            could_further_improve: "Could further improve",
            members_excel: "members excel",
            members_could_improve: "members could further improve",
            peer_feedback_rating: "Peer Feedback Rating",
            rank: "Rank",
            average_rating: "Average Rating",
            interactions: "Interactions",
            peer_feedback: "Peer Feedback",
            behaviors_title: "Feedback behaviors by person",
            behaviors_description: "How actively each person takes part in peer feedback, from asking for it to giving it to others, with the average rating they receive",
            loading_behaviors: "Loading peer feedback activity...",
            requests_made: "Requests Made",
            feedback_given: "Feedback Given",
            participation: "Participation",
            requested: "Requested",
            received: "Received",
            given: "Given",
            no_behaviors: "No peer feedback activity in this period",
            strengths_title: "Strengths & development areas",
            strengths_description: "Skills peers recognize as strengths and where they see room to grow, to guide learning and development priorities",
            strength_mentions: "Strength Mentions",
            development_mentions: "Development Mentions",
            development_areas: "Development areas",
            strengths: "Strengths",
            mentions_label: "mentions",
            people_label: "people",
            showing_top_skills: "Showing the 10 most-mentioned skills",
            members_label: "members",
            no_skill_mentions: "No skills feedback in this period",
            total_ratings: "Total Ratings",
            ratings_label: "ratings",
            no_ratings: "No peer feedback ratings in this period",
            asked: "Asked",
            receiving_feedback: "Receiving Feedback",
            giving_feedback: "Giving Feedback",
            response_rate: "Response %",
            response_rate_hint: "Of the feedback peers asked this person for, the share they gave back",
            rating_short: "Rating",
            requested_hint: "Feedback requests this person sent to peers",
            received_hint: "Feedback responses this person received from peers",
            asked_hint: "Feedback requests peers sent to this person",
            given_hint: "Feedback responses this person gave to peers",
            average_rating_hint: "Average peer rating, from 1 (Needs Improvement) to 4 (Truly Outstanding)",
            participation_hint: "Share of members who requested or gave feedback in this period",
            skill_details: "Skill details",
            by_attribute: "By attribute",
            attribute_hint: "Share of mentions that highlighted each attribute",
        },
    },
    focus: {
        last_7_days: "Last 7 days",
        last_30_days: "Last 30 days",
        last_60_days: "Last 60 days",
        last_90_days: "Last 90 days",
    },
    programs: {
        Completion_reward: "Reward",
        Add_completion_reward: "Add reward",
        Currency_coins: "Coins",
        Currency_gems: "Gems",
        Currency_xp: "XP",
        Reward_needs_value: "1 reward needs a value",
        Reward_reason_placeholder: "Why are they getting this?",
    },
};
